webpackJsonp([44],{

/***/ "+OsR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/bZG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/kga":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/prevent-body-scroll.js + 1 modules
var prevent_body_scroll = __webpack_require__("JkZY");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-347e3f32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-dialog/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-dialog",class:{'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'}},[_c('transition',{attrs:{"name":_vm.maskTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-mask",style:(_vm.maskStyle),on:{"click":_vm.hide}})]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.dialogTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:_vm.dialogClass,style:(_vm.dialogStyle)},[_vm._t("default")],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_x_dialog = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-dialog/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("fgbW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_x_dialog,
  src_components_x_dialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_dialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5h2b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "62KO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/components/x-dialog/index.vue + 3 modules
var x_dialog = __webpack_require__("/kga");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var src_components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c48d9308","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/confirm/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-confirm"},[_c('x-dialog',{attrs:{"dialog-class":_vm.theme === 'android' ? 'weui-dialog weui-skin_android' : 'weui-dialog',"mask-transition":_vm.maskTransition,"dialog-transition":_vm.theme === 'android' ? 'vux-fade' : _vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){_vm.$emit('on-hide')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[(!!_vm.title)?_c('div',{staticClass:"weui-dialog__hd",class:{'with-no-content': !_vm.showContent}},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._v(" "),(_vm.showContent)?[(!_vm.showInput)?_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],2):_c('div',{staticClass:"vux-prompt"},[_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder},domProps:{"value":(_vm.msg)},on:{"touchend":_vm.setInputFocus,"input":function($event){if($event.target.composing){ return; }_vm.msg=$event.target.value}}},'input',_vm.getInputAttrs(),false))])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[(_vm.showCancelButton)?_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_default",attrs:{"href":"javascript:;"},on:{"click":_vm._onCancel}},[_vm._v(_vm._s(_vm.cancelText || '取消'))]):_vm._e(),_vm._v(" "),(_vm.showConfirmButton)?_c('a',{staticClass:"weui-dialog__btn",class:("weui-dialog__btn_" + _vm.confirmType),attrs:{"href":"javascript:;"},on:{"click":_vm._onConfirm}},[_vm._v(_vm._s(_vm.confirmText || '确定'))]):_vm._e()])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var vux_src_components_confirm = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/confirm/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("fghJ")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_components_confirm,
  vux_src_components_confirm,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var node_modules_vux_src_components_confirm = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "7YgM":
/***/ (function(module, exports) {

module.exports = {"name":"web_glocalme","version":"1.0.19-SP03-B01","description":"GlocalMe","author":"uCloudLink.com","private":true,"scripts":{"dev":"webpack-dev-server --inline --progress --config build/webpack.dev.conf.js","start":"npm run dev","unit":"cross-env BABEL_ENV=test karma start test/unit/karma.conf.js --single-run","e2e":"node test/e2e/runner.js","test":"npm run unit && npm run e2e","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs","build":"node build/build.js"},"dependencies":{"axios":"^0.18.0","babel-polyfill":"^6.26.0","clipboard":"^2.0.1","dexie":"^2.0.4","fastclick":"^1.0.6","js-base64":"^2.4.5","js-cookie":"^2.2.0","lib-flexible":"^0.3.2","quagga":"^0.12.1","dsbridge":"^3.1.3","vue":"^2.5.2","vue-i18n":"^7.6.0","vue-router":"^3.0.1","vuex":"^2.5.0","vuex-i18n":"^1.3.1","vuex-router-sync":"^5.0.0","vux":"^2.9.4","weixin-js-sdk":"^1.3.3","mescroll.js":"^1.4.2","swiper":"4.5.1","vconsole":"3.3.4"},"devDependencies":{"autoprefixer":"^7.1.2","babel-core":"^6.22.1","babel-eslint":"^7.1.1","babel-helper-vue-jsx-merge-props":"^2.0.3","babel-loader":"^7.1.1","babel-plugin-istanbul":"^4.1.1","babel-plugin-syntax-jsx":"^6.18.0","babel-plugin-transform-runtime":"^6.22.0","babel-plugin-transform-vue-jsx":"^3.5.1","babel-polyfill":"^6.26.0","babel-preset-env":"^1.3.2","babel-preset-stage-2":"^6.22.0","babel-register":"^6.22.0","chai":"^4.1.2","chalk":"^2.0.1","chromedriver":"^2.27.2","compression-webpack-plugin":"^0.3.2","connect-history-api-fallback":"^1.3.0","copy-webpack-plugin":"^4.0.1","cross-env":"^5.0.1","cross-spawn":"^5.0.1","css-loader":"^0.28.0","eslint":"^3.19.0","eslint-friendly-formatter":"^3.0.0","eslint-loader":"^1.7.1","eslint-plugin-html":"^3.0.0","eventsource-polyfill":"^0.9.6","extract-text-webpack-plugin":"^3.0.0","file-loader":"^1.1.4","friendly-errors-webpack-plugin":"^1.6.1","generate-asset-webpack-plugin":"^0.3.0","html-webpack-plugin":"^2.30.1","inject-loader":"^3.0.0","karma":"^1.4.1","karma-coverage":"^1.1.1","karma-mocha":"^1.3.0","karma-phantomjs-launcher":"^1.0.2","karma-phantomjs-shim":"^1.4.0","karma-sinon-chai":"^1.3.1","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.31","karma-webpack":"^2.0.2","less":"^2.7.1","less-loader":"^2.2.3","mocha":"^3.2.0","mockjs":"^1.0.1-beta3","nightwatch":"^0.9.12","node-notifier":"^5.1.2","optimize-css-assets-webpack-plugin":"^3.2.0","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.14","portfinder":"^1.0.13","postcss-import":"^11.0.0","postcss-loader":"^2.0.8","px2rem-loader":"^0.1.9","rimraf":"^2.6.0","selenium-server":"^3.0.1","semver":"^5.3.0","shelljs":"^0.7.6","sinon":"^4.0.0","sinon-chai":"^2.8.0","url-loader":"^0.5.8","vue-loader":"^13.3.0","vue-style-loader":"^3.0.1","vue-template-compiler":"^2.5.2","vux-loader":"^1.0.56","webpack":"^3.6.0","webpack-bundle-analyzer":"^2.9.0","webpack-dev-middleware":"^1.10.0","webpack-dev-server":"^2.9.1","webpack-hot-middleware":"^2.16.1","webpack-merge":"^4.1.0","yaml-loader":"^0.4.0"},"engines":{"node":">= 4.0.0","npm":">= 3.0.0"},"browserslist":["> 1%","last 2 versions","not ie <= 8"]}

/***/ }),

/***/ "ABCa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/object-assign/index.js
var object_assign = __webpack_require__("BEQ0");
var object_assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_header = ({
  name: 'x-header',
  props: {
    leftOptions: Object,
    title: String,
    transition: String,
    rightOptions: {
      type: Object,
      default: function _default() {
        return {
          showMore: false
        };
      }
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots['overwrite-title']) {
      this.shouldOverWriteTitle = true;
    }
  },

  computed: {
    _leftOptions: function _leftOptions() {
      return object_assign_default()({
        showBack: true,
        preventGoBack: false
      }, this.leftOptions || {});
    }
  },
  methods: {
    onClickBack: function onClickBack() {
      if (this._leftOptions.preventGoBack) {
        this.$emit('on-click-back');
      } else {
        this.$router ? this.$router.back() : window.history.back();
      }
    }
  },
  data: function data() {
    return {
      shouldOverWriteTitle: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_header = ({
  name: 'x-header',
  props: {
    leftOptions: Object,
    title: String,
    transition: String,
    rightOptions: {
      type: Object,
      default: function _default() {
        return {
          showMore: false
        };
      }
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots['overwrite-title']) {
      this.shouldOverWriteTitle = true;
    }
  },

  computed: {
    _leftOptions: function _leftOptions() {
      return object_assign_default()({
        showBack: true,
        preventGoBack: false
      }, this.leftOptions || {});
    }
  },
  methods: {
    onClickBack: function onClickBack() {
      if (this._leftOptions.preventGoBack) {
        this.$emit('on-click-back');
      } else {
        this.$router ? this.$router.back() : window.history.back();
      }
    }
  },
  data: function data() {
    return {
      shouldOverWriteTitle: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb223dbe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-header/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-header"},[_c('div',{staticClass:"vux-header-left"},[_vm._t("overwrite-left",[_c('transition',{attrs:{"name":_vm.transition}},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm._leftOptions.showBack),expression:"_leftOptions.showBack"}],staticClass:"vux-header-back",on:{"click":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"preventDefault",undefined,$event.key)){ return null; }},_vm.onClickBack]}},[_vm._v(_vm._s(typeof _vm._leftOptions.backText === 'undefined' ? '返回' : _vm._leftOptions.backText))])]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm._leftOptions.showBack),expression:"_leftOptions.showBack"}],staticClass:"left-arrow",on:{"click":_vm.onClickBack}})])]),_vm._v(" "),_vm._t("left")],2),_vm._v(" "),(!_vm.shouldOverWriteTitle)?_c('h1',{staticClass:"vux-header-title",on:{"click":function($event){_vm.$emit('on-click-title')}}},[_vm._t("default",[_c('transition',{attrs:{"name":_vm.transition}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.title),expression:"title"}]},[_vm._v(_vm._s(_vm.title))])])])],2):_vm._e(),_vm._v(" "),(_vm.shouldOverWriteTitle)?_c('div',{staticClass:"vux-header-title-area"},[_vm._t("overwrite-title")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"vux-header-right"},[(_vm.rightOptions.showMore)?_c('a',{staticClass:"vux-header-more",on:{"click":[function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"preventDefault",undefined,$event.key)){ return null; }},function($event){_vm.$emit('on-click-more')}]}}):_vm._e(),_vm._v(" "),_vm._t("right")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_x_header = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-header/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("KBty")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_x_header,
  src_components_x_header,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var vux_src_components_x_header = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "B+uB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Bfwr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/loading/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_loading = ({
  name: 'loading',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: Boolean,
    text: String,
    position: String,
    transition: {
      type: String,
      default: 'vux-mask'
    }
  },
  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a79aa162","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/loading/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-loading_toast vux-loading",class:!_vm.text ? 'vux-loading-no-text' : ''},[_c('div',{staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('div',{staticClass:"weui-toast",style:({
        position: _vm.position
      })},[_c('i',{staticClass:"weui-loading weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content"},[_vm._v(_vm._s(_vm.text || '加载中')),_vm._t("default")],2):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_loading = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/loading/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("x79i")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_loading,
  src_components_loading,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var vux_src_components_loading = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "K81I":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KBty":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/babel-polyfill/lib/index.js
var lib = __webpack_require__("j1ja");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./src/utils/cookie.js
var cookie = __webpack_require__("iPXC");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//



/* harmony default export */ var App = ({
    name: 'app',
    methods: {
        debug: function debug(ele, fn) {
            var count = 0;
            var timeRange = 5000;
            var beginTime, time;
            var that = this;
            ele.addEventListener("click", function () {
                if (count == 0) {
                    beginTime = new Date().getTime();
                    count++;
                } else {
                    time = new Date().getTime();
                    if (time - beginTime >= timeRange) {
                        if (count >= 20) {
                            fn.call(that);
                            count = 0;
                        } else {
                            count = 0;
                            beginTime = null;
                        }
                    } else {
                        count++;
                    }
                }
            }, false);
        }
    },
    mounted: function mounted() {
        var _this = this;

        window.dsBridge.register('changeSystemLang', function (lang) {
            if (['zh-CN', 'en-US', 'zh-TW'].includes(lang)) {
                _this.$i18n.locale = lang;
                cookie["a" /* default */].set("lang", lang);
                window.location.reload();
            }
        });
        this.debug(document, function () {
            if (_this.$config.env !== 'prod') {
                _this.$vux.toast.show({
                    text: "已启用调试模式",
                    type: "text",
                    onHide: function onHide() {
                        _this.$router.push({ name: 'test' });
                    }
                });
            }
        });
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//



/* harmony default export */ var selectortype_script_index_0_src_App = ({
    name: 'app',
    methods: {
        debug: function debug(ele, fn) {
            var count = 0;
            var timeRange = 5000;
            var beginTime, time;
            var that = this;
            ele.addEventListener("click", function () {
                if (count == 0) {
                    beginTime = new Date().getTime();
                    count++;
                } else {
                    time = new Date().getTime();
                    if (time - beginTime >= timeRange) {
                        if (count >= 20) {
                            fn.call(that);
                            count = 0;
                        } else {
                            count = 0;
                            beginTime = null;
                        }
                    } else {
                        count++;
                    }
                }
            }, false);
        }
    },
    mounted: function mounted() {
        var _this = this;

        window.dsBridge.register('changeSystemLang', function (lang) {
            if (['zh-CN', 'en-US', 'zh-TW'].includes(lang)) {
                _this.$i18n.locale = lang;
                cookie["a" /* default */].set("lang", lang);
                window.location.reload();
            }
        });
        this.debug(document, function () {
            if (_this.$config.env !== 'prod') {
                _this.$vux.toast.show({
                    text: "已启用调试模式",
                    type: "text",
                    onHide: function onHide() {
                        _this.$router.push({ name: 'test' });
                    }
                });
            }
        });
    }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5dd4f24e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"router-view"},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: App_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("/bZG")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/router/index.js



vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
    base: '/webmall/',
    mode: 'history',
    routes: [{
        path: '*',
        name: '404',
        meta: {
            title: '404'
        },
        component: function component(resolve) {
            __webpack_require__.e/* require */(33).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("+H76")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/neterror',
        name: 'net-error',
        meta: {
            title: '网络错误'
        },
        component: function component(resolve) {
            Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(18)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("k+B+")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, { path: "/", redirect: "/packages/index" }, {
        path: "/login",
        name: "login",
        meta: {
            title: '登录'
        },
        component: function component(resolve) {
            __webpack_require__.e/* require */(21).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Quw4")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: "/test",
        name: "test",
        meta: {
            title: '调试页面'
        },
        component: function component(resolve) {
            __webpack_require__.e/* require */(38).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("BERp")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: "/index",
        name: "index",
        meta: {
            title: '首页'
        },
        component: function component(resolve) {
            Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("pgai")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: "/packages/index",
        name: "package-list",
        meta: {
            title: '单国流量套餐列表'
        },
        component: function component(resolve) {
            Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(6)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("hMRT")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: "/order/payment",
        name: "order-payment",
        meta: {
            title: '订单支付'
        },
        component: function component(resolve) {
            Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(9)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("gW+W")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: "/order/success",
        name: "order-success",
        meta: {
            title: '订单支付成功'
        },
        component: function component(resolve) {
            Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(7)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("+Y9V")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: "/order/jump",
        name: "order-jump",
        meta: {
            title: 'Loading...'
        },
        component: function component(resolve) {
            __webpack_require__.e/* require */(42).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("YWPI")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: "/order/waitingForConfirm",
        name: "waiting-for-confirm",
        meta: {
            title: '订单支付待确认'
        },
        component: function component(resolve) {
            __webpack_require__.e/* require */(20).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("l0sd")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: "/point",
        name: "point-index",
        meta: {
            title: '会员积分首页'
        },
        component: function component(resolve) {
            Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(4)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("WKsE")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: "/point/history",
        name: "point-history",
        meta: {
            title: '会员积分明细'
        },
        component: function component(resolve) {
            Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(12)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("8QYA")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: "/point/exchange",
        name: "point-exchange",
        meta: {
            title: '积分兑换'
        },
        component: function component(resolve) {
            Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(5)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("0e46")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: "/memberShip",
        name: "member-ship",
        meta: {
            title: '会员权益首页'
        },
        component: function component(resolve) {
            Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("aexU")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: "/memberShip/benefit",
        name: "member-benefit",
        meta: {
            title: '会员权益列表'
        },
        component: function component(resolve) {
            Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(29)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ApfP")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: "/memberShip/faq",
        name: "member-faq",
        meta: {
            title: '常见问题'
        },
        component: function component(resolve) {
            Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(14)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("3Esi")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: "/memberShip/policy",
        name: "member-policy",
        meta: {
            title: '会员隐私'
        },
        component: function component(resolve) {
            Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(40)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("SvHV")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: "/memberShip/introduce",
        name: "member-introduce",
        meta: {
            title: '会员介绍'
        },
        component: function component(resolve) {
            Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(15)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("V8pr")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/memberShip/giveSet',
        name: 'give-set',
        meta: {
            title: '赠送流量设置'
        },
        component: function component(resolve) {
            Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(11)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("JqgR")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: "/faq/index",
        name: "faq-index",
        meta: {
            title: '常见问题'
        },
        component: function component(resolve) {
            Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(19)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("3bq6")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: "/faq/deviceList",
        name: "device-list",
        meta: {
            title: '全部设备'
        },
        component: function component(resolve) {
            Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(25)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("I5Dw")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: "/faq/faqList",
        name: "faq-list",
        meta: {
            title: '常见问题'
        },
        component: function component(resolve) {
            Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(39)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("aZCJ")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: "/faq/otherFaqList",
        name: "faq-list",
        meta: {
            title: '常见问题'
        },
        component: function component(resolve) {
            Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(31)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("luyO")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: "/faq/otherFaqDetail",
        name: "faq-list",
        meta: {
            title: '常见问题详情'
        },
        component: function component(resolve) {
            Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(30)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ZL/g")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: "/faq/faqDetail",
        name: "faq-detail",
        meta: {
            title: '详情'
        },
        component: function component(resolve) {
            Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(41)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("iOO6")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: "/device/index",
        name: "device-index",
        meta: {
            title: '设备手册'
        },
        component: function component(resolve) {
            Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(23)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("5sW+")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: "/device/deviceDetail",
        name: "device-detail",
        meta: {
            title: '设备详情'
        },
        component: function component(resolve) {
            Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(36)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("lJtY")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: "/vpn/faqList",
        name: "vpn-faq",
        meta: {
            title: "VPN常见问题"
        },
        component: function component(resolve) {
            Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(34)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Qtmh")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: "/ota/faq/:classes",
        name: "ota-faq",
        meta: {
            title: "ota常见问题"
        },
        component: function component(resolve) {
            Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(35)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("zXvi")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: "/vpn/faqDetail",
        name: "vpn-faq-detail",
        meta: {
            title: '详情'
        },
        component: function component(resolve) {
            Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(26)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("YW4O")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: "/ota/faq/:classes/faqDetail",
        name: "ota-faq-detail",
        meta: {
            title: '详情'
        },
        component: function component(resolve) {
            Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(17)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("zFBk")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: "/deviceGuide/index",
        name: "device-guide-index",
        meta: {
            title: "设备引导"
        },
        component: function component(resolve) {
            Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(28)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("QlB6")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: "/petDeviceGuide/index",
        name: "device-guide-index",
        meta: {
            title: "宠物设备引导"
        },
        component: function component(resolve) {
            Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(24)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("zIly")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: "/deviceGuide/deviceDetail",
        name: "device-guide-detail",
        component: function component(resolve) {
            Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(22)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("pT2g")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: "/petDeviceGuide/deviceDetail",
        name: "device-guide-detail",
        component: function component(resolve) {
            Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(27)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("AUhL")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: "/deviceGuide/deviceDetailChange",
        name: "device-detail-change",
        component: function component(resolve) {
            Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(37)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("aetS")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: "/petDeviceGuide/deviceDetailChange",
        name: "device-detail-change",
        component: function component(resolve) {
            Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(32)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("kzEw")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/guide/newUser',
        name: 'new-user-guide',
        component: function component(resolve) {
            Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(13)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Gt2a")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/invite/shareCode',
        name: '拉新分享',
        component: function component(resolve) {
            Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(10)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("jyQ8")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/invite/newRegister',
        name: '新用户填写邀请码',
        meta: {
            title: "新用户填写邀请码"
        },
        component: function component(resolve) {
            Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(8)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("rULj")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/invite/invitationHistory',
        name: '拉新记录',
        component: function component(resolve) {
            Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(16)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("JYNQ")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }, {
        path: '/esim/redemption',
        name: 'esim兑换',
        component: function component(resolve) {
            __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("5fiU")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
        }
    }]
}));
// CONCATENATED MODULE: ./src/config/config.js
/**
 * 公共参数的配置文件
 * **/

var api = {
    quickUserLogin: '/bss/app/noauth/QuickUserLogin',
    // 单国家流量包
    queryOfferList: '/bss/app/noauth/QueryOfferList',
    // 州流量包
    queryRecommendOfferList: '/bss/app/noauth/QueryRecommendOfferList',
    // 积分 -- Redeem Coupon
    queryIntegralPromotionList: '/bss/app/integral/QueryIntegralPromotionList',
    // 积分 -- Redeem Package、Redeem Top-up Card
    queryIntegralGoodList: '/bss/app/integral/QueryIntegralGoodList',
    // 用户积分
    queryUserIntegral: '/bss/app/integral/QueryUserIntegral',
    // 用户积分明细
    queryIntegralDetailes: '/bss/app/integral/QueryIntegralDetailes',
    dictionary: '/aps/dictionary/query',
    // 获取会员状态
    queryUserVIPState: '/bss/app/user/queryUserVIPState',
    // 查询会员权益
    queryVIPBenefitsByGoods: '/bss/app/integral/QueryVIPBenefitsByGoods',
    // 查询优惠券
    queryCustPromotionByGoods: '/bss/app/promotion/queryCustPromotionByGoods',
    // 查询账户余额
    queryBalanceInfo: '/bss/app/user/QueryBalanceInfo',
    // 创建订单
    createOrder: '/bss/app/order/CreateOrder',
    // 使用账户余额支付接口
    doPayByBalance: '/bss/app/order/DoPayByBalance',
    // 提前计算下单需要的费用
    preCalcOrder: '/bss/app/order/PreCalcOrder',
    // 在线支付调用
    //business_order_internal_create: '/business/order/internal/create',
    // 中台收银台下单接口
    cashier_createorder: '/webmps/payment/cashier/createorder',
    queryOrderListForApp: '/bss/app/order/queryOrderListForApp',
    //获取用户信息
    getUserInfo: '/bss/app/user/QueryUserInfo',
    //首页banner
    queryBanner: '/webmps/marketing/banner/queryAll',
    //首页专属套餐列表
    queryCustomOfferList: '/bss/app/noauth/QueryCustomOfferList',
    //首页热门地区推荐
    queryDictionaryValueListInfo: '/bss/app/noauth/dictionary/QueryDictionaryValueListInfo',
    //跨区域套餐展示
    queryRecommendLowPrice: '/bss/app/noauth/QueryRecommendLowPrice',
    //当前所在地获取
    queryOnlineTerminal: '/bss/app/terminal/QueryOnlineTerminal',
    //覆盖国家列表
    queryCoverCountyInfo: '/bss/app/noauth/QueryCoverCountyInfo',
    // 查询用户绑定的设备
    queryGroupList: '/bss/app/group/QueryGroupList',
    makeInviterCode: '/bss/app/user/MakeInviterCode',
    queryInviteesJoinActList: '/bss/app/act/queryInviteesJoinActList',
    getVerificationCode: '/mms/app/httpApi/v1/esim/getVerificationCode'

};

var config_config = {
    api: api,
    request: {
        partnerCode: 'UKAPP',
        streamNoHead: 'APP'
    }
};

/* harmony default export */ var src_config_config = (config_config);
// EXTERNAL MODULE: ./src/data/app-config.js
var app_config = __webpack_require__("kJS3");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/classCallCheck.js
var classCallCheck = __webpack_require__("Zrlr");
var classCallCheck_default = /*#__PURE__*/__webpack_require__.n(classCallCheck);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/createClass.js
var createClass = __webpack_require__("wxAW");
var createClass_default = /*#__PURE__*/__webpack_require__.n(createClass);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// EXTERNAL MODULE: ./src/utils/util.js
var util = __webpack_require__("oFuF");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// EXTERNAL MODULE: ./node_modules/dsbridge/index.js
var dsbridge = __webpack_require__("r7UA");
var dsbridge_default = /*#__PURE__*/__webpack_require__.n(dsbridge);

// CONCATENATED MODULE: ./src/utils/request.js



/**
 * Created by tao.li on 2018/2/27.
 */








//window._axiosPromiseArr = [];

var service = axios_default.a.create({
    timeout: 600000,
    auth: true,
    baseURL: window.location.origin,
    method: 'post',
    loading: true // 是否显示loading
});

var METHOD_MAP = {
    'get': 'params',
    'post': 'data'
};

// cookie.remove('access_token');
// cookie.remove('access_token', {domain: location.hostname});

// 获取app的登录信息
var request_loginInfo = JSON.parse(window.dsBridge.call('getLoginMsg') || '{}');
cookie["a" /* default */].set("lang", request_loginInfo.langType || cookie["a" /* default */].get("lang") || 'en-US');
if (request_loginInfo.mvnoCode || cookie["a" /* default */].get("mvnoCode")) cookie["a" /* default */].set("mvnoCode", request_loginInfo.mvnoCode || cookie["a" /* default */].get("mvnoCode"));
if (request_loginInfo.access_token || cookie["a" /* default */].get('access_token')) cookie["a" /* default */].set('access_token', request_loginInfo.access_token || cookie["a" /* default */].get('access_token') || '');

service.interceptors.request.use(function (config) {
    if (config.loading) vue_esm["a" /* default */].$vux.loading.show();

    /*config.cancelToken = new axios.CancelToken(cancel => {
        window._axiosPromiseArr.push({cancel});
    });*/

    var authParams = {};

    var commonParams = {
        streamNo: src_config_config.request.streamNoHead + new Date().getTime() + parseInt(Math.random() * 1000000),
        partnerCode: src_config_config.request.partnerCode,
        langType: request_loginInfo.langType || cookie["a" /* default */].get("lang") || 'en-US',
        loginCustomerId: request_loginInfo.loginCustomerId || cookie["a" /* default */].get('loginCustomerId') || '',
        mvnoCode: request_loginInfo.mvnoCode || cookie["a" /* default */].get('mvnoCode') || 'GCGROUP',
        orgId: request_loginInfo.orgId || cookie["a" /* default */].get('orgId') || '',
        access_token: request_loginInfo.access_token || cookie["a" /* default */].get('access_token') || ''
    };

    /*
    * 添加通用参数
    * */
    config.headers["Accept-Language"] = request_loginInfo.langType || cookie["a" /* default */].get("lang") || "en-US";
    config.headers["app_version"] = request_loginInfo.app_version;
    config.headers["access_token"] = request_loginInfo.access_token || cookie["a" /* default */].get('access_token');
    if (!config.noCommon) {
        config[METHOD_MAP[config.method]] = extends_default()({}, commonParams, config[METHOD_MAP[config.method]]);
    } else {
        config[METHOD_MAP[config.method]] = extends_default()({}, config[METHOD_MAP[config.method]]);
    }

    /*
    * 添加验证参数
    * */
    if (config.auth === true) {
        config[METHOD_MAP[config.method]] = extends_default()({}, config[METHOD_MAP[config.method]], authParams);
    }
    /*
    * 过滤值为空参数
    * */
    config[METHOD_MAP[config.method]] && keys_default()(config[METHOD_MAP[config.method]]).forEach(function (val) {
        if (Object(util["isUndefOrEmpty"])(config[METHOD_MAP[config.method]][val])) {
            delete config[METHOD_MAP[config.method]][val];
        }
    });

    return config;
}, function (error) {
    promise_default.a.reject(error);
});

service.interceptors.response.use(function (response) {
    vue_esm["a" /* default */].$vux.loading.hide();

    var resultCode = response.data.resultCode;
    var resultDesc = response.data.resultDesc;

    if (resultCode === '00000000') {
        return response.data;
    } else {
        if (resultCode === '00000008' || resultCode === '00000007' || resultCode === '00000006') {
            /*
             * 00000008 => AccessToken does not belong to the loginCustomer
             * 00000007 => The access token expired
             * 00000006 => AccessToken is null
             * */
            window.dsBridge.call('nativeLogin');
        } else {
            return promise_default.a.reject(response.data);
        }
    }
}, function (error) {
    vue_esm["a" /* default */].$vux.loading.hide();
    // 跳转到网络错误页面
    router.push({
        name: 'net-error'
    });
    return promise_default.a.reject('');
});

/* harmony default export */ var request = (service);
// CONCATENATED MODULE: ./src/utils/storage.js

/**
 * Created by dingkang.li on 2018/2/28.
 */
var store = localStorage;

var Storage = {};

Storage.setStorage = function (key, value) {
  return store.setItem(key, stringify_default()(value));
};

Storage.getStorage = function (key) {
  return JSON.parse(store.getItem(key));
};

Storage.clearStorage = function (key) {
  store.removeItem(key);
};

Storage.clearAllStorage = function () {
  store.clear();
};

/* harmony default export */ var storage = (Storage);
// CONCATENATED MODULE: ./src/dao/DataStore.js









var DataStore_DataStore = function () {
    function DataStore() {
        classCallCheck_default()(this, DataStore);
    }

    createClass_default()(DataStore, [{
        key: 'fetchData',
        value: function fetchData(options) {
            var _this = this;

            return new promise_default.a(function (resolve, reject) {
                _this.fetchLocalData(options.url).then(function (data) {
                    if (data && DataStore.expirationTimeVerification(data.cacheTime)) {
                        resolve(data);
                    } else {
                        _this.fetchNetData(options).then(function (res) {
                            if (res.resultCode == "00000000") {
                                resolve(res);
                            } else {
                                vue_esm["a" /* default */].$vux.toast.show({
                                    type: 'text',
                                    text: res.resultDesc || '网络错误',
                                    time: 2000,
                                    width: "4rem"
                                });
                            }
                        }, function (err) {
                            vue_esm["a" /* default */].$vux.toast.show({
                                type: 'text',
                                text: err || '网络错误',
                                time: 2000,
                                width: "4rem"
                            });
                            reject(err);
                        });
                    }
                }, function (err) {
                    _this.fetchNetData(options).then(function (res) {
                        resolve(res);
                    }, function (err) {
                        reject(err);
                    });
                });
            });
        }

        // 获取本地数据

    }, {
        key: 'fetchLocalData',
        value: function fetchLocalData(url) {
            return new promise_default.a(function (resolve, reject) {
                try {
                    var data = JSON.parse(storage.getStorage(url));
                    resolve(data);
                } catch (err) {
                    reject(err);
                }
            });
        }

        // 获取网络数据

    }, {
        key: 'fetchNetData',
        value: function fetchNetData(options) {
            vue_esm["a" /* default */].$vux.loading.show({
                text: "加载中"
            });
            return new promise_default.a(function (resolve, reject) {
                request(options).then(function (res) {
                    DataStore.saveData(options.url, res);
                    resolve(res);
                    vue_esm["a" /* default */].$vux.loading.hide();
                }, function (err) {
                    reject(err);
                    vue_esm["a" /* default */].$vux.loading.hide();
                });
            });
        }
    }], [{
        key: 'saveData',
        value: function saveData(url, data) {
            storage.setStorage(url, stringify_default()(DataStore.wrapperData(data)));
        }
    }, {
        key: 'wrapperData',
        value: function wrapperData(data) {
            var cacheTime = new Date().getTime();
            return { cacheTime: cacheTime, data: data };
        }
    }, {
        key: 'expirationTimeVerification',
        value: function expirationTimeVerification(cacheTime) {
            var currentTime = new Date().getTime();
            var expireHour = src_config_config.expireHour;
            if (currentTime - cacheTime > expireHour * 60 * 60 * 1000) return false;
            return true;
        }
    }]);

    return DataStore;
}();

/* harmony default export */ var dao_DataStore = (DataStore_DataStore);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("lbHh");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// CONCATENATED MODULE: ./src/store/app.js



var app = {
    state: {
        vipFlag: false
    },
    mutations: {
        UPDTE_VIP_FLAG: function UPDTE_VIP_FLAG(state, val) {
            state.vipFlag = val;
        }
    },
    actions: {
        update_vip_flag: function update_vip_flag(_ref, val) {
            var commit = _ref.commit;

            commit('UPDTE_VIP_FLAG', val);
        }
    }
};

/* harmony default export */ var store_app = (app);
// CONCATENATED MODULE: ./src/store/getters.js
var getters = {
    vipFlag: function vipFlag(state) {
        return state.app.vipFlag;
    }
};

/* harmony default export */ var store_getters = (getters);
// CONCATENATED MODULE: ./src/store/index.js







vue_esm["a" /* default */].use(vuex_esm["a" /* default */]);

var store_store = new vuex_esm["a" /* default */].Store({
    modules: {
        app: store_app
    },
    getters: store_getters
});

/* harmony default export */ var src_store = (store_store);
// EXTERNAL MODULE: ./src/lang/index.js + 6 modules
var src_lang = __webpack_require__("cEaa");

// EXTERNAL MODULE: ./src/filters/filters.js
var filters = __webpack_require__("V1NV");
var filters_default = /*#__PURE__*/__webpack_require__.n(filters);

// CONCATENATED MODULE: ./src/filters/index.js

/**
 * Created by desheng.zhao on 2018/11/30.
 */


// 全局过滤器
var global = extends_default()({}, filters);

// 局部过滤器
var local = extends_default()({}, filters);
// EXTERNAL MODULE: ./node_modules/vux/src/components/x-header/index.vue + 3 modules
var x_header = __webpack_require__("ABCa");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/base.js + 1 modules
var base = __webpack_require__("f6Hi");

// EXTERNAL MODULE: ./node_modules/vux/src/components/icon/index.vue + 3 modules
var icon = __webpack_require__("oWtu");

// EXTERNAL MODULE: ./node_modules/vux/src/components/toast/index.vue + 3 modules
var toast = __webpack_require__("rLAy");

// EXTERNAL MODULE: ./node_modules/vux/src/components/inline-desc/index.vue + 3 modules
var inline_desc = __webpack_require__("kbG3");

// EXTERNAL MODULE: ./node_modules/validator/lib/isEmail.js
var isEmail = __webpack_require__("2LX0");
var isEmail_default = /*#__PURE__*/__webpack_require__.n(isEmail);

// EXTERNAL MODULE: ./node_modules/validator/lib/isMobilePhone.js
var isMobilePhone = __webpack_require__("Ewe+");
var isMobilePhone_default = /*#__PURE__*/__webpack_require__.n(isMobilePhone);

// EXTERNAL MODULE: ./node_modules/vux/src/tools/debounce/index.js
var debounce = __webpack_require__("nror");

// EXTERNAL MODULE: ./node_modules/vanilla-masker/lib/vanilla-masker.js
var vanilla_masker = __webpack_require__("lFEC");
var vanilla_masker_default = /*#__PURE__*/__webpack_require__.n(vanilla_masker);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-input/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var validators = {
  'email': {
    fn: isEmail_default.a,
    msg: '邮箱格式'
  },
  'china-mobile': {
    fn: function fn(str) {
      return isMobilePhone_default()(str, 'zh-CN');
    },

    msg: '手机号码'
  },
  'china-name': {
    fn: function fn(str) {
      return str.length >= 2 && str.length <= 6;
    },

    msg: '中文姓名'
  }
};
/* harmony default export */ var x_input = ({
  name: 'x-input',
  created: function created() {
    var _this = this;

    this.currentValue = this.value === undefined || this.value === null ? '' : this.mask ? this.maskValue(this.value) : this.value;
    /* istanbul ignore if */
    if (false) {
      if (!this.title && !this.placeholder && !this.currentValue) {
        console.warn('no title and no placeholder?');
      }
    }

    if (this.required && (typeof this.currentValue === 'undefined' || this.currentValue === '')) {
      this.valid = false;
    }
    this.handleChangeEvent = true;
    if (this.debounce) {
      this._debounce = Object(debounce["a" /* default */])(function () {
        _this.$emit('on-change', _this.currentValue);
      }, this.debounce);
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    if (this.$slots && this.$slots['right-full-height']) {
      this.hasRightFullHeightSlot = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._debounce) {
      this._debounce.cancel();
    }
    window.removeEventListener('resize', this.scrollIntoView);
  },

  mixins: [base["a" /* default */]],
  components: {
    Icon: icon["a" /* default */],
    InlineDesc: inline_desc["a" /* default */],
    Toast: toast["a" /* default */]
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    value: [String, Number],
    name: String,
    readonly: Boolean,
    disabled: Boolean,
    keyboard: String,
    inlineDesc: String,
    isType: [String, Function],
    min: Number,
    max: Number,
    showClear: {
      type: Boolean,
      default: true
    },
    equalWith: String,
    textAlign: String,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    novalidate: {
      type: Boolean,
      default: false
    },
    iconType: String,
    debounce: Number,
    placeholderAlign: String,
    labelWidth: String,
    mask: String,
    shouldToastError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: this.labelWidthComputed || $parent.labelWidth || this.labelWidthComputed,
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    pattern: function pattern() {
      if (this.keyboard === 'number' || this.isType === 'china-mobile') {
        return '[0-9]*';
      }
    },
    labelWidthComputed: function labelWidthComputed() {
      var width = this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
      if (width < 10) {
        return width + 'em';
      }
    },
    hasErrors: function hasErrors() {
      return keys_default()(this.errors).length > 0;
    },
    inputStyle: function inputStyle() {
      if (this.textAlign) {
        return {
          textAlign: this.textAlign
        };
      }
    },
    showWarn: function showWarn() {
      return !this.novalidate && !this.equalWith && !this.valid && this.firstError && (this.touched || this.forceShowError);
    }
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.scrollIntoView);
  },

  methods: {
    scrollIntoView: function scrollIntoView() {
      var _this2 = this;

      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      // alert('scroll into view')
      if (/iphone/i.test(navigator.userAgent)) {
        // return
      }
      if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        // alert('will scroll')
        setTimeout(function () {
          // alert(this.$refs.input.length)
          _this2.$refs.input.scrollIntoViewIfNeeded(true);
        }, time);
      }
    },
    onClickErrorIcon: function onClickErrorIcon() {
      if (this.shouldToastError && this.firstError) {
        this.showErrorToast = true;
      }
      this.$emit('on-click-error-icon', this.firstError);
    },
    maskValue: function maskValue(val) {
      var val1 = this.mask ? vanilla_masker_default.a.toPattern(val, this.mask) : val;
      return val1;
    },
    reset: function reset() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.dirty = false;
      this.currentValue = value;
      this.firstError = '';
      this.valid = true;
    },
    clear: function clear() {
      this.currentValue = '';
      this.focus();
      this.$emit('on-click-clear-icon');
    },
    focus: function focus() {
      this.$refs.input.focus();
    },
    blur: function blur() {
      this.$refs.input.blur();
    },
    focusHandler: function focusHandler($event) {
      var _this3 = this;

      this.$emit('on-focus', this.currentValue, $event);
      this.isFocus = true;
      // this.scrollIntoView(500)
      // this.scrollIntoView(5000)
      setTimeout(function () {
        // 因为有1秒的延迟，如果切换了页面，input已经不存在，所以加个判断
        !_this3.$refs.input || _this3.$refs.input.scrollIntoViewIfNeeded(false);
        // this.$refs.input.scrollIntoViewIfNeeded()
      }, 1000);
      // $event.target.
    },
    onBlur: function onBlur($event) {
      this.setTouched();
      this.validate();
      this.isFocus = false;
      this.$emit('on-blur', this.currentValue, $event);
    },
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'Enter') {
        e.target.blur();
        this.$emit('on-enter', this.currentValue, e);
      }
    },
    getError: function getError() {
      var key = keys_default()(this.errors)[0];
      this.firstError = this.errors[key];
    },
    validate: function validate() {
      if (typeof this.equalWith !== 'undefined') {
        this.validateEqual();
        return;
      }
      this.errors = {};

      if (!this.currentValue && !this.required) {
        this.valid = true;
        return;
      }

      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填哦';
        this.getError();
        return;
      }

      if (typeof this.isType === 'string') {
        var validator = validators[this.isType];
        if (validator) {
          var value = this.currentValue;

          if (this.isType === 'china-mobile' && this.mask === '999 9999 9999') {
            value = this.currentValue.replace(/\s+/g, '');
          }

          this.valid = validator['fn'](value);
          if (!this.valid) {
            this.forceShowError = true;
            this.errors.format = validator['msg'] + '格式不对哦~';
            this.getError();
            return;
          } else {
            delete this.errors.format;
          }
        }
      }

      if (typeof this.isType === 'function') {
        var validStatus = this.isType(this.currentValue);
        this.valid = validStatus.valid;
        if (!this.valid) {
          this.errors.format = validStatus.msg;
          this.forceShowError = true;
          this.getError();
          return;
        } else {
          delete this.errors.format;
        }
      }

      if (this.min) {
        if (this.currentValue.length < this.min) {
          this.errors.min = '\u6700\u5C11\u5E94\u8BE5\u8F93\u5165' + this.min + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.getError();
          return;
        } else {
          delete this.errors.min;
        }
      }

      if (this.max) {
        if (this.currentValue.length > this.max) {
          this.errors.max = '\u6700\u591A\u53EF\u4EE5\u8F93\u5165' + this.max + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.forceShowError = true;
          return;
        } else {
          this.forceShowError = false;
          delete this.errors.max;
        }
      }

      this.valid = true;
    },
    validateEqual: function validateEqual() {
      if (!this.equalWith && this.currentValue) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      }
      var willCheck = this.dirty || this.currentValue.length >= this.equalWith.length;
      // 只在长度符合时显示正确与否
      if (willCheck && this.currentValue !== this.equalWith) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      } else {
        if (!this.currentValue && this.required) {
          this.valid = false;
        } else {
          this.valid = true;
          delete this.errors.equal;
        }
      }
    },

    // #2810
    _getInputMaskSelection: function _getInputMaskSelection(selection, direction, maskVal, loop) {
      if (!this.mask || loop && direction === 0) {
        return selection;
      }
      if (direction === 0) {
        direction = this.lastDirection;
      }
      if (direction > 0) {
        var maskChar = this.mask.substr(selection - direction, 1);
        if (!maskChar.match(/[9SA]/)) {
          return this._getInputMaskSelection(selection + 1, direction, maskVal, true);
        }
      }
      return selection;
    }
  },
  data: function data() {
    return {
      hasRightFullHeightSlot: false,
      hasRestrictedLabel: false,
      firstError: '',
      forceShowError: false,
      hasLengthEqual: false,
      valid: true,
      currentValue: '',
      showErrorToast: false,
      isFocus: false
    };
  },

  watch: {
    mask: function mask(val) {
      if (val && this.currentValue) {
        this.currentValue = this.maskValue(this.currentValue);
      }
    },
    valid: function valid() {
      this.getError();
    },
    value: function value(val) {
      this.currentValue = val;
    },
    equalWith: function equalWith(newVal) {
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
    },
    currentValue: function currentValue(newVal, oldVal) {
      var _this4 = this;

      var selection = null;
      if (!this.equalWith && newVal) {
        this.validateEqual();
      }
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
      // #2960
      try {
        selection = this.$refs.input.selectionStart;
        var direction = newVal.length - oldVal.length;
        selection = this._getInputMaskSelection(selection, direction, this.maskValue(newVal));
        this.lastDirection = direction;
      } catch (e) {}
      this.$emit('input', this.maskValue(newVal));
      // #2810
      this.$nextTick(function () {
        if (_this4.$refs.input.selectionStart !== selection) {
          _this4.$refs.input.selectionStart = selection;
          _this4.$refs.input.selectionEnd = selection;
        }
        if (_this4.currentValue !== _this4.maskValue(newVal)) {
          _this4.currentValue = _this4.maskValue(newVal);
        }
      });

      if (this._debounce) {
        this._debounce();
      } else {
        this.$emit('on-change', newVal);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-input/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var x_input_validators = {
  'email': {
    fn: isEmail_default.a,
    msg: '邮箱格式'
  },
  'china-mobile': {
    fn: function fn(str) {
      return isMobilePhone_default()(str, 'zh-CN');
    },

    msg: '手机号码'
  },
  'china-name': {
    fn: function fn(str) {
      return str.length >= 2 && str.length <= 6;
    },

    msg: '中文姓名'
  }
};
/* harmony default export */ var components_x_input = ({
  name: 'x-input',
  created: function created() {
    var _this = this;

    this.currentValue = this.value === undefined || this.value === null ? '' : this.mask ? this.maskValue(this.value) : this.value;
    /* istanbul ignore if */
    if (false) {
      if (!this.title && !this.placeholder && !this.currentValue) {
        console.warn('no title and no placeholder?');
      }
    }

    if (this.required && (typeof this.currentValue === 'undefined' || this.currentValue === '')) {
      this.valid = false;
    }
    this.handleChangeEvent = true;
    if (this.debounce) {
      this._debounce = Object(debounce["a" /* default */])(function () {
        _this.$emit('on-change', _this.currentValue);
      }, this.debounce);
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    if (this.$slots && this.$slots['right-full-height']) {
      this.hasRightFullHeightSlot = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._debounce) {
      this._debounce.cancel();
    }
    window.removeEventListener('resize', this.scrollIntoView);
  },

  mixins: [base["a" /* default */]],
  components: {
    Icon: icon["a" /* default */],
    InlineDesc: inline_desc["a" /* default */],
    Toast: toast["a" /* default */]
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    value: [String, Number],
    name: String,
    readonly: Boolean,
    disabled: Boolean,
    keyboard: String,
    inlineDesc: String,
    isType: [String, Function],
    min: Number,
    max: Number,
    showClear: {
      type: Boolean,
      default: true
    },
    equalWith: String,
    textAlign: String,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    novalidate: {
      type: Boolean,
      default: false
    },
    iconType: String,
    debounce: Number,
    placeholderAlign: String,
    labelWidth: String,
    mask: String,
    shouldToastError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: this.labelWidthComputed || $parent.labelWidth || this.labelWidthComputed,
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    pattern: function pattern() {
      if (this.keyboard === 'number' || this.isType === 'china-mobile') {
        return '[0-9]*';
      }
    },
    labelWidthComputed: function labelWidthComputed() {
      var width = this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
      if (width < 10) {
        return width + 'em';
      }
    },
    hasErrors: function hasErrors() {
      return keys_default()(this.errors).length > 0;
    },
    inputStyle: function inputStyle() {
      if (this.textAlign) {
        return {
          textAlign: this.textAlign
        };
      }
    },
    showWarn: function showWarn() {
      return !this.novalidate && !this.equalWith && !this.valid && this.firstError && (this.touched || this.forceShowError);
    }
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.scrollIntoView);
  },

  methods: {
    scrollIntoView: function scrollIntoView() {
      var _this2 = this;

      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      // alert('scroll into view')
      if (/iphone/i.test(navigator.userAgent)) {
        // return
      }
      if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        // alert('will scroll')
        setTimeout(function () {
          // alert(this.$refs.input.length)
          _this2.$refs.input.scrollIntoViewIfNeeded(true);
        }, time);
      }
    },
    onClickErrorIcon: function onClickErrorIcon() {
      if (this.shouldToastError && this.firstError) {
        this.showErrorToast = true;
      }
      this.$emit('on-click-error-icon', this.firstError);
    },
    maskValue: function maskValue(val) {
      var val1 = this.mask ? vanilla_masker_default.a.toPattern(val, this.mask) : val;
      return val1;
    },
    reset: function reset() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.dirty = false;
      this.currentValue = value;
      this.firstError = '';
      this.valid = true;
    },
    clear: function clear() {
      this.currentValue = '';
      this.focus();
      this.$emit('on-click-clear-icon');
    },
    focus: function focus() {
      this.$refs.input.focus();
    },
    blur: function blur() {
      this.$refs.input.blur();
    },
    focusHandler: function focusHandler($event) {
      var _this3 = this;

      this.$emit('on-focus', this.currentValue, $event);
      this.isFocus = true;
      // this.scrollIntoView(500)
      // this.scrollIntoView(5000)
      setTimeout(function () {
        // 因为有1秒的延迟，如果切换了页面，input已经不存在，所以加个判断
        !_this3.$refs.input || _this3.$refs.input.scrollIntoViewIfNeeded(false);
        // this.$refs.input.scrollIntoViewIfNeeded()
      }, 1000);
      // $event.target.
    },
    onBlur: function onBlur($event) {
      this.setTouched();
      this.validate();
      this.isFocus = false;
      this.$emit('on-blur', this.currentValue, $event);
    },
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'Enter') {
        e.target.blur();
        this.$emit('on-enter', this.currentValue, e);
      }
    },
    getError: function getError() {
      var key = keys_default()(this.errors)[0];
      this.firstError = this.errors[key];
    },
    validate: function validate() {
      if (typeof this.equalWith !== 'undefined') {
        this.validateEqual();
        return;
      }
      this.errors = {};

      if (!this.currentValue && !this.required) {
        this.valid = true;
        return;
      }

      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填哦';
        this.getError();
        return;
      }

      if (typeof this.isType === 'string') {
        var validator = x_input_validators[this.isType];
        if (validator) {
          var value = this.currentValue;

          if (this.isType === 'china-mobile' && this.mask === '999 9999 9999') {
            value = this.currentValue.replace(/\s+/g, '');
          }

          this.valid = validator['fn'](value);
          if (!this.valid) {
            this.forceShowError = true;
            this.errors.format = validator['msg'] + '格式不对哦~';
            this.getError();
            return;
          } else {
            delete this.errors.format;
          }
        }
      }

      if (typeof this.isType === 'function') {
        var validStatus = this.isType(this.currentValue);
        this.valid = validStatus.valid;
        if (!this.valid) {
          this.errors.format = validStatus.msg;
          this.forceShowError = true;
          this.getError();
          return;
        } else {
          delete this.errors.format;
        }
      }

      if (this.min) {
        if (this.currentValue.length < this.min) {
          this.errors.min = '\u6700\u5C11\u5E94\u8BE5\u8F93\u5165' + this.min + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.getError();
          return;
        } else {
          delete this.errors.min;
        }
      }

      if (this.max) {
        if (this.currentValue.length > this.max) {
          this.errors.max = '\u6700\u591A\u53EF\u4EE5\u8F93\u5165' + this.max + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.forceShowError = true;
          return;
        } else {
          this.forceShowError = false;
          delete this.errors.max;
        }
      }

      this.valid = true;
    },
    validateEqual: function validateEqual() {
      if (!this.equalWith && this.currentValue) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      }
      var willCheck = this.dirty || this.currentValue.length >= this.equalWith.length;
      // 只在长度符合时显示正确与否
      if (willCheck && this.currentValue !== this.equalWith) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      } else {
        if (!this.currentValue && this.required) {
          this.valid = false;
        } else {
          this.valid = true;
          delete this.errors.equal;
        }
      }
    },

    // #2810
    _getInputMaskSelection: function _getInputMaskSelection(selection, direction, maskVal, loop) {
      if (!this.mask || loop && direction === 0) {
        return selection;
      }
      if (direction === 0) {
        direction = this.lastDirection;
      }
      if (direction > 0) {
        var maskChar = this.mask.substr(selection - direction, 1);
        if (!maskChar.match(/[9SA]/)) {
          return this._getInputMaskSelection(selection + 1, direction, maskVal, true);
        }
      }
      return selection;
    }
  },
  data: function data() {
    return {
      hasRightFullHeightSlot: false,
      hasRestrictedLabel: false,
      firstError: '',
      forceShowError: false,
      hasLengthEqual: false,
      valid: true,
      currentValue: '',
      showErrorToast: false,
      isFocus: false
    };
  },

  watch: {
    mask: function mask(val) {
      if (val && this.currentValue) {
        this.currentValue = this.maskValue(this.currentValue);
      }
    },
    valid: function valid() {
      this.getError();
    },
    value: function value(val) {
      this.currentValue = val;
    },
    equalWith: function equalWith(newVal) {
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
    },
    currentValue: function currentValue(newVal, oldVal) {
      var _this4 = this;

      var selection = null;
      if (!this.equalWith && newVal) {
        this.validateEqual();
      }
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
      // #2960
      try {
        selection = this.$refs.input.selectionStart;
        var direction = newVal.length - oldVal.length;
        selection = this._getInputMaskSelection(selection, direction, this.maskValue(newVal));
        this.lastDirection = direction;
      } catch (e) {}
      this.$emit('input', this.maskValue(newVal));
      // #2810
      this.$nextTick(function () {
        if (_this4.$refs.input.selectionStart !== selection) {
          _this4.$refs.input.selectionStart = selection;
          _this4.$refs.input.selectionEnd = selection;
        }
        if (_this4.currentValue !== _this4.maskValue(newVal)) {
          _this4.currentValue = _this4.maskValue(newVal);
        }
      });

      if (this._debounce) {
        this._debounce();
      } else {
        this.$emit('on-change', newVal);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d0aeed9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-input/index.vue
var x_input_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-input weui-cell",class:{
			'weui-cell_warn': _vm.showWarn,
			'disabled': _vm.disabled,
			'vux-x-input-has-right-full': _vm.hasRightFullHeightSlot
		}},[_c('div',{staticClass:"weui-cell__hd"},[(_vm.hasRestrictedLabel)?_c('div',{style:(_vm.labelStyles)},[_vm._t("restricted-label")],2):_vm._e(),_vm._v(" "),_vm._t("label",[(_vm.title)?_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:({width: _vm.labelWidth || _vm.$parent.labelWidth || _vm.labelWidthComputed, textAlign: _vm.$parent.labelAlign, marginRight: _vm.$parent.labelMarginRight}),attrs:{"for":("vux-x-input-" + _vm.uuid)},domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd weui-cell__primary",class:_vm.placeholderAlign ? ("vux-x-input-placeholder-" + _vm.placeholderAlign) : ''},[(!_vm.type || _vm.type === 'text')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"text","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'number')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"number","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'email')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"email","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'password')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"password","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'tel')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"tel","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hasRightFullHeightSlot && !_vm.equalWith && _vm.showClear && _vm.currentValue !== '' && !_vm.readonly && !_vm.disabled && _vm.isFocus),expression:"!hasRightFullHeightSlot && !equalWith && showClear && currentValue !== '' && !readonly && !disabled && isFocus"}],attrs:{"type":"clear"},nativeOn:{"click":function($event){_vm.clear($event)}}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.showWarn),expression:"showWarn"}],staticClass:"vux-input-icon",attrs:{"type":"warn","title":!_vm.valid ? _vm.firstError : ''},nativeOn:{"click":function($event){_vm.onClickErrorIcon($event)}}}),_vm._v(" "),(!_vm.novalidate && _vm.hasLengthEqual && _vm.dirty && _vm.equalWith && !_vm.valid)?_c('icon',{staticClass:"vux-input-icon",attrs:{"type":"warn"},nativeOn:{"click":function($event){_vm.onClickErrorIcon($event)}}}):_vm._e(),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.novalidate && _vm.equalWith && _vm.equalWith === _vm.currentValue && _vm.valid),expression:"!novalidate && equalWith && equalWith === currentValue && valid"}],attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.novalidate && _vm.iconType === 'success'),expression:"novalidate && iconType === 'success'"}],staticClass:"vux-input-icon",attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.novalidate && _vm.iconType === 'error'),expression:"novalidate && iconType === 'error'"}],staticClass:"vux-input-icon",attrs:{"type":"warn"}}),_vm._v(" "),_vm._t("right"),_vm._v(" "),(_vm.hasRightFullHeightSlot)?_c('div',{staticClass:"vux-x-input-right-full"},[_vm._t("right-full-height")],2):_vm._e()],2),_vm._v(" "),_c('toast',{attrs:{"type":"text","width":"auto","time":600},model:{value:(_vm.showErrorToast),callback:function ($$v) {_vm.showErrorToast=$$v},expression:"showErrorToast"}},[_vm._v(_vm._s(_vm.firstError))])],1)}
var x_input_staticRenderFns = []
var x_input_esExports = { render: x_input_render, staticRenderFns: x_input_staticRenderFns }
/* harmony default export */ var src_components_x_input = (x_input_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-input/index.vue
function x_input_injectStyle (ssrContext) {
  __webpack_require__("K81I")
}
var x_input_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_input___vue_template_functional__ = false
/* styles */
var x_input___vue_styles__ = x_input_injectStyle
/* scopeId */
var x_input___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_input___vue_module_identifier__ = null
var x_input_Component = x_input_normalizeComponent(
  components_x_input,
  src_components_x_input,
  x_input___vue_template_functional__,
  x_input___vue_styles__,
  x_input___vue_scopeId__,
  x_input___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_input = (x_input_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/router.js
var libs_router = __webpack_require__("0FxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(libs_router["a" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(libs_router["a" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5f075ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-button/index.vue
var x_button_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"weui-btn",class:_vm.classes,style:(_vm.buttonStyle),attrs:{"disabled":_vm.disabled,"type":_vm.actionType},on:{"click":_vm.onClick}},[(_vm.showLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e(),_vm._v(" "),_vm._t("default",[_vm._v(_vm._s(_vm.text))])],2)}
var x_button_staticRenderFns = []
var x_button_esExports = { render: x_button_render, staticRenderFns: x_button_staticRenderFns }
/* harmony default export */ var src_components_x_button = (x_button_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-button/index.vue
function x_button_injectStyle (ssrContext) {
  __webpack_require__("oy94")
}
var x_button_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_button___vue_template_functional__ = false
/* styles */
var x_button___vue_styles__ = x_button_injectStyle
/* scopeId */
var x_button___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_button___vue_module_identifier__ = null
var x_button_Component = x_button_normalizeComponent(
  components_x_button,
  src_components_x_button,
  x_button___vue_template_functional__,
  x_button___vue_styles__,
  x_button___vue_scopeId__,
  x_button___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_button = (x_button_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/group/index.vue + 3 modules
var group = __webpack_require__("rHil");

// EXTERNAL MODULE: ./node_modules/vux/src/components/cell/props.js
var props = __webpack_require__("2IIR");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/clean-style.js
var clean_style = __webpack_require__("wmxo");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/get-parent-prop.js
var get_parent_prop = __webpack_require__("vLYD");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var cell = ({
  name: 'cell',
  components: {
    InlineDesc: inline_desc["a" /* default */]
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return Object(clean_style["a" /* default */])({
        width: Object(get_parent_prop["a" /* default */])(this, 'labelWidth'),
        textAlign: Object(get_parent_prop["a" /* default */])(this, 'labelAlign'),
        marginRight: Object(get_parent_prop["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && Object(libs_router["a" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var components_cell = ({
  name: 'cell',
  components: {
    InlineDesc: inline_desc["a" /* default */]
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return Object(clean_style["a" /* default */])({
        width: Object(get_parent_prop["a" /* default */])(this, 'labelWidth'),
        textAlign: Object(get_parent_prop["a" /* default */])(this, 'labelAlign'),
        marginRight: Object(get_parent_prop["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && Object(libs_router["a" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62e51266","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/cell/index.vue
var cell_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell",class:{
    'vux-tap-active': _vm.isLink || !!_vm.link,
    'weui-cell_access': _vm.isLink || !!_vm.link,
    'vux-cell-no-border-intent': !_vm.borderIntent,
    'vux-cell-disabled': _vm.disabled
  },style:(_vm.style),on:{"click":_vm.onClick}},[_c('div',{staticClass:"weui-cell__hd"},[_vm._t("icon")],2),_vm._v(" "),_c('div',{staticClass:"vux-cell-bd",class:{'vux-cell-primary': _vm.primary === 'title' && _vm.valueAlign !== 'left'}},[_c('p',[(_vm.title || _vm.hasTitleSlot)?_c('label',{staticClass:"vux-label",class:_vm.labelClass,style:(_vm.labelStyles)},[_vm._t("title",[_vm._v(_vm._s(_vm.title))])],2):_vm._e(),_vm._v(" "),_vm._t("after-title")],2),_vm._v(" "),_c('inline-desc',[_vm._t("inline-desc",[_vm._v(_vm._s(_vm.inlineDesc))])],2)],1),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft",class:_vm.valueClass},[_vm._t("value"),_vm._v(" "),_vm._t("default",[_vm._v(_vm._s(_vm.value))]),_vm._v(" "),(_vm.isLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e()],2),_vm._v(" "),_vm._t("child")],2)}
var cell_staticRenderFns = []
var cell_esExports = { render: cell_render, staticRenderFns: cell_staticRenderFns }
/* harmony default export */ var src_components_cell = (cell_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/cell/index.vue
function cell_injectStyle (ssrContext) {
  __webpack_require__("TQ26")
}
var cell_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var cell___vue_template_functional__ = false
/* styles */
var cell___vue_styles__ = cell_injectStyle
/* scopeId */
var cell___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var cell___vue_module_identifier__ = null
var cell_Component = cell_normalizeComponent(
  components_cell,
  src_components_cell,
  cell___vue_template_functional__,
  cell___vue_styles__,
  cell___vue_scopeId__,
  cell___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_cell = (cell_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/alert/index.vue + 3 modules
var components_alert = __webpack_require__("mzja");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/line-row.vue

/* harmony default export */ var line_row = ({
    name: 'line-row',
    props: {
        height: {
            type: [String, Number],
            default: 16
        },
        background: {
            type: String,
            default: 'transparent'
        }
    },
    computed: {
        heightRem: function heightRem() {
            // 效果图以360尺寸为基准
            return this.height * 1 / 36;
        }
    },
    render: function render() {
        var h = arguments[0];

        return h(
            'div',
            null,
            [h('div', {
                class: 'line-row',
                style: {
                    height: this.heightRem + 'rem',
                    background: this.background
                }
            })]
        );
    }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/line-row.vue

/* harmony default export */ var components_line_row = ({
    name: 'line-row',
    props: {
        height: {
            type: [String, Number],
            default: 16
        },
        background: {
            type: String,
            default: 'transparent'
        }
    },
    computed: {
        heightRem: function heightRem() {
            // 效果图以360尺寸为基准
            return this.height * 1 / 36;
        }
    },
    render: function render() {
        var h = arguments[0];

        return h(
            'div',
            null,
            [h('div', {
                class: 'line-row',
                style: {
                    height: this.heightRem + 'rem',
                    background: this.background
                }
            })]
        );
    }
});
// CONCATENATED MODULE: ./src/components/line-row.vue
var line_row_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var line_row___vue_template_functional__ = false
/* styles */
var line_row___vue_styles__ = null
/* scopeId */
var line_row___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var line_row___vue_module_identifier__ = null
var line_row_Component = line_row_normalizeComponent(
  components_line_row,
  __vue_template__,
  line_row___vue_template_functional__,
  line_row___vue_styles__,
  line_row___vue_scopeId__,
  line_row___vue_module_identifier__
)

/* harmony default export */ var src_components_line_row = (line_row_Component.exports);

// CONCATENATED MODULE: ./src/components/index.js









var components_global = {
  XHeader: x_header["a" /* default */], XInput: vux_src_components_x_input, XButton: vux_src_components_x_button, Group: group["a" /* default */], Cell: vux_src_components_cell, Alert: components_alert["a" /* default */], LineRow: src_components_line_row
};
// EXTERNAL MODULE: ./node_modules/vux/src/directives/transfer-dom/index.js
var transfer_dom = __webpack_require__("63CM");

// CONCATENATED MODULE: ./src/directives/num-format.js
/* harmony default export */ var num_format = ({
	four: { //4-4-4-4-4
		update: function update(el, binding) {
			if (binding.value.length != 1) {
				return;
			}
			var val = el.value || el.innerText;
			//每次输入的时候先把分隔符去掉
			var reg = new RegExp(binding.value, 'g');
			val = val.replace(reg, "");
			var arr = val.split("");

			var format = "";
			for (var i = 0; i < arr.length; i++) {
				if (i % 4 == 0 && i != 0) {
					format += binding.value;
				}
				format += arr[i];
			}
			el.value = format;
			// el.innerText = format;
		}
	},
	txt: {
		inserted: function inserted(el, binding) {
			if (binding.value.length != 1) {
				return;
			}
			var val = el.innerText;
			console.log(val);
			//每次输入的时候先把分隔符去掉
			var reg = new RegExp(binding.value, 'g');
			val = val.replace(reg, "");
			var arr = val.split("");

			var format = "";
			for (var i = 0; i < arr.length; i++) {
				if (i % 4 == 0 && i != 0) {
					format += binding.value;
				}
				format += arr[i];
			}
			el.innerText = format;
		}
	},
	tel: { //手机号3-4-4
		update: function update(el, binding) {
			if (binding.value.length != 1) {
				return;
			}
			var val = el.value;
			//每次输入的时候先把分隔符去掉
			var reg = new RegExp(binding.value, 'g');
			val = val.replace(reg, "");
			var arr = val.split("");

			for (var i = 0; i < arr.length; i++) {
				if (i == 3) {
					arr.splice(3, 0, binding.value);
				} else if (i == 3 + 1 + 4) {
					arr.splice(3 + 1 + 4, 0, binding.value);
				}
			}
			el.value = arr.join("");
		}
	},
	iosbug: {
		inserted: function inserted(el, binding) {
			el.onblur = function () {
				setTimeout(function () {
					document.dispatchEvent(new Event('touchmove'));
					var doc = document.body || document.documentElement;
					var scrollTop = doc.scrollTop;
					doc.scrollTop = scrollTop + 10;
					setTimeout(function () {
						doc.scrollTop = scrollTop;
					}, 30);
				}, 100);
			};
		}
	}
});
// CONCATENATED MODULE: ./src/directives/index.js





var directives_global = extends_default()({
  TransferDom: transfer_dom["a" /* default */]
}, num_format);

var directives_local = extends_default()({
  TransferDom: transfer_dom["a" /* default */]
}, num_format);
// EXTERNAL MODULE: ./node_modules/vux/src/plugins/loading/index.js
var loading = __webpack_require__("Y+qm");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/alert/index.js + 1 modules
var plugins_alert = __webpack_require__("Peep");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/toast/index.js
var plugins_toast = __webpack_require__("3BeM");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/datetime/index.js
var datetime = __webpack_require__("oVYx");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/confirm/index.js
var plugins_confirm = __webpack_require__("NXWw");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/wechat/index.js + 1 modules
var wechat = __webpack_require__("n6Wb");

// CONCATENATED MODULE: ./src/plugins/globalFn.js




function globalFn_toast(text) {
    var _this = this;

    var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2000;
    var cb = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    vue_esm["a" /* default */].$vux.toast.show({
        type: "text",
        text: text,
        time: time,
        position: "bottom",
        onHide: function onHide() {
            cb && cb.call(_this);
        }
    });
}

/* harmony default export */ var globalFn = ({
    install: function install(Vue, options) {
        Vue.prototype.$api = src_config_config.api;
        Vue.prototype.$cookie = cookie["a" /* default */];
        Vue.prototype.$config = src_config_config;
        Vue.prototype.$toast = globalFn_toast;
    }
});
// CONCATENATED MODULE: ./src/plugins/http.js




var Http = {};

Http.install = function (Vue) {
  var opt = {
    method: 'post',
    auth: true
  };
  Vue.prototype.$http = function (opts) {
    opts = assign_default()({}, opt, opts);
    return new promise_default.a(function (resolve, reject) {
      request(opts).then(function (res) {
        if (opts.filter && typeof opts.filter === 'function') {
          // res.data.data => 真正的数据
          if (res.data.data) {
            res.data.data = opts.filter(res.data.data);
          }
        }
        if (res) resolve(res);
      }, function (res) {
        if (res) reject(res);
      });
    });
  };

  ['get', 'post', 'delete', 'put'].forEach(function (type) {
    Vue.prototype.$http[type] = function (opts) {
      opts.method = type;
      return Vue.prototype.$http(opts);
    };
  });
};

/* harmony default export */ var http = (Http);
// CONCATENATED MODULE: ./src/plugins/index.js










var plugins_global = {
  LoadingPlugin: loading["a" /* default */],
  AlertPlugin: plugins_alert["a" /* default */],
  ToastPlugin: plugins_toast["a" /* default */],
  DatetimePlugin: datetime["a" /* default */],
  ConfirmPlugin: plugins_confirm["a" /* default */],
  globalFn: globalFn,
  Http: http,
  WechatPlugin: wechat["a" /* default */]
};
// CONCATENATED MODULE: ./src/mixin/index.js





// 点击节流, 防止多次打开activety
var throttle_timer = null;

var mixin_app = {
    data: function data() {
        return {
            updateVipSelectRow: {},
            // 会员介绍页面季度和年度会员价格
            introduceObj: {
                annual: '',
                quarterly: '',
                currencyType: ''
            }
        };
    },

    methods: {
        throttleClickItem: function throttleClickItem(fn) {
            var _this = this,
                _arguments = arguments;

            var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;

            if (!throttle_timer) {
                throttle_timer = setTimeout(function () {
                    throttle_timer = null;
                    fn.apply(_this, _arguments);
                }, wait);
            }
        },
        goActive: function goActive(opt) {
            if (this.$config.envType === 'app') {
                opt.appCallback && opt.appCallback();
            } else if (this.$config.envType === 'h5') {
                opt.webCallback && opt.webCallback();
            }
        },
        queryUpdateVipGoods: function queryUpdateVipGoods() {
            var _this2 = this;

            var channelType = window.dsBridge.call('getChannelType') || 'APP';
            this.$http.post({
                url: this.$api.queryOfferList,
                data: {
                    goodsType: 'COMM',
                    categoryCode: 'MBCP',
                    channelType: channelType
                }
            }).then(function (res) {
                if (res.data && res.data.dataList && res.data.dataList.length > 0) {

                    var introduceObjCurrencyType = '';
                    var annuals = [];
                    var quarterlys = [];

                    res.data.dataList.forEach(function (row) {
                        introduceObjCurrencyType = row.currencyType;
                        if (row.payAgreeFlag == "1" && row.deductionInfo != null && row.deductionInfo.autoRenewActCode != null) {
                            var autoRenewFirstPrice = row.deductionInfo.autoRenewFirstPrice ? row.deductionInfo.autoRenewFirstPrice : 0.0;
                            if (autoRenewFirstPrice > 0 && autoRenewFirstPrice < row.goodsPrice) {
                                row.goodsPriceText = util_default.a.keepTwodecimalFull(autoRenewFirstPrice / 100);
                                row.listPrice = util_default.a.keepTwodecimalFull(row.goodsPrice / 100);
                            } else {
                                row.goodsPriceText = util_default.a.keepTwodecimalFull((row.discountPrice != null ? row.discountPrice : row.goodsPrice) / 100);
                            }
                        } else {
                            row.goodsPriceText = util_default.a.keepTwodecimalFull((row.discountPrice != null ? row.discountPrice : row.goodsPrice) / 100);
                            if (row.discountPrice != null) {
                                row.listPrice = util_default.a.keepTwodecimalFull(row.goodsPrice / 100);
                            }
                        }

                        if (row.periodUnit == 'MONTH') {
                            if (row.period == 12) {
                                row.periodText = '1';
                                row.periodUnitText = _this2.$t('order.periodUnit.year');
                                row.priceOfMonth = util_default.a.keepTwodecimalFixed(row.goodsPriceText / 12);
                                annuals.push(row); // 年度会员
                            } else {
                                row.periodText = row.period;
                                if (row.period > 1) {
                                    row.periodUnitText = _this2.$t('order.periodUnits.month');
                                } else {
                                    row.periodUnitText = _this2.$t('order.periodUnit.month');
                                }
                                row.priceOfMonth = util_default.a.keepTwodecimalFixed(row.goodsPriceText / row.period);

                                if (row.period == 3) {
                                    quarterlys.push(row); // 季度会员
                                }
                            }
                        }
                    });
                    /*
                    * 计算会员介绍页面的季度和年度会员的价格
                    * */
                    if (quarterlys.length) {
                        quarterlys.sort(function (a, b) {
                            return b.goodsPriceText * 1 - a.goodsPriceText * 1;
                        });
                        _this2.introduceObj.quarterly = quarterlys[0];
                    } else {
                        _this2.introduceObj.quarterly = {
                            currencyType: introduceObjCurrencyType,
                            goodsPriceText: '58'
                        };
                    }
                    if (annuals.length) {
                        annuals.sort(function (a, b) {
                            return b.goodsPriceText * 1 - a.goodsPriceText * 1;
                        });
                        _this2.introduceObj.annual = annuals[0];
                    } else {
                        _this2.introduceObj.annual = {
                            currencyType: introduceObjCurrencyType,
                            goodsPriceText: '198'
                        };
                    }
                    /*
                     * 计算会员介绍页面的季度和年度会员的价格
                     * */

                    res.data.dataList.sort(function (a, b) {
                        return a.discountPrice * 1 - b.discountPrice * 1;
                    });
                    _this2.updateVipSelectRow = res.data.dataList[0];
                }
            });
        },
        appLogin: function appLogin(_ref) {
            var userCode = _ref.userCode,
                password = _ref.password,
                mvnoCode = _ref.mvnoCode,
                loginType = _ref.loginType,
                channelType = _ref.channelType,
                partnerCode = _ref.partnerCode,
                langType = _ref.langType,
                clientId = _ref.clientId,
                clientSecret = _ref.clientSecret;

            if (cookie["a" /* default */].get('accessToken')) return;
            return this.$http.post({
                url: this.$api.quickUserLogin,
                data: {
                    "streamNo": this.$config.request.streamNoHead + new Date().getTime() + parseInt(Math.random() * 1000000),
                    "clientId": clientId || "xjh",
                    userCode: userCode,
                    password: password,
                    "randomId": '',
                    'clientSecret': clientSecret || '123456',
                    'mvnoCode': mvnoCode || 'GCGROUP',
                    "loginType": loginType || "PWD",
                    "channelType": channelType || "APP",
                    "enterpriseCode": "",
                    "randomKey": "",
                    "langType": langType || "zh-CN",
                    "partnerCode": partnerCode || "UKAPP"
                }
            }).then(function (res) {
                cookie["a" /* default */].setCookies([{
                    key: 'access_token',
                    value: res.accessToken
                }, {
                    key: 'loginCustomerId',
                    value: res.userId
                }, {
                    key: 'orgId',
                    value: res.orgId
                }, {
                    key: 'mvnoCode',
                    value: res.mvnoCode || ''
                    //value: 'GlocM'
                }, {
                    key: 'orgCode',
                    value: res.orgCode || ''
                }, {
                    key: 'userId',
                    value: res.userId || ''
                }]);
                return res;
            });
        },
        webLoading: function webLoading() {
            // 判断是否允许访问H5
            /*if(this.$config.allow_access_to_h5) {
                window.dsBridge.call('WebLoading', true);
             } else {
                let keys = Object.keys(this.$config.app_info); // 本地配置的所有字段
                let has_value_keys = []; // 本地配置有值的字段集合
                if(keys.length > 0) {
                    let all_null = true; // 被配置字段是否全部设值
                    keys.forEach(key => {
                        if(this.$config.app_info[key]) {
                            has_value_keys.push(key);
                            all_null = false;
                        }
                    });
                    if(all_null) { // 配置的字段全部没有值，不允许访问
                        window.dsBridge.call('webLoading', false);
                    } else {
                        let app_info = JSON.parse(window.dsBridge.call('getInfo', 'AppMessage') || '{}');
                        let reg_num = 0; //配置字段有多少个匹配到
                        has_value_keys.forEach(key => {
                            if(this.$config.app_info[key] && app_info[key] && this.$config.app_info[key] === app_info) {
                                reg_num++;
                            }
                        });
                        if(reg_num == has_value_keys.length) { // 全部匹配到，满足不被允许访问条件
                            window.dsBridge.call('webLoading', false);
                        } else {
                            window.dsBridge.call('webLoading', true);
                        }
                    }
                 } else {
                    window.dsBridge.call('webLoading', false);
                }
             }*/
            if (this.$config.allow_access_to_h5) {
                window.dsBridge.call('WebLoading', true);
            } else {
                window.dsBridge.call('WebLoading', false);
            }
        },
        getOnlineTermimal: function getOnlineTermimal() {
            this.$http.post({
                url: this.$api.queryOnlineTerminal
            }).then(function (res) {
                return res;
            });
        },
        queryCoverCountyInfo: function queryCoverCountyInfo() {
            return this.$http.post({
                url: this.$api.queryCoverCountyInfo
            });
        },
        getCountryName: function getCountryName(code) {
            var _this3 = this;

            return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
                var res, countryName;
                return regenerator_default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;
                                _context.next = 3;
                                return _this3.queryCoverCountyInfo();

                            case 3:
                                res = _context.sent;
                                countryName = res.data && res.data.find(function (item) {
                                    return item.iso2 == code.toUpperCase();
                                }).countryName;
                                return _context.abrupt('return', countryName);

                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context['catch'](0);

                            case 10:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this3, [[0, 8]]);
            }))();
        },

        // 赠送流量包版本兼容
        giveSetVersionCompatible: function giveSetVersionCompatible() {
            if (window.dsBridge.hasNativeMethod('toScan') && window.dsBridge.hasNativeMethod('bindByType')) {
                return true; // 兼容新版本
            } else {
                return false; // 不兼容新版本
            }
        }
    }
};

var mixin_global = {
    app: mixin_app
};
// CONCATENATED MODULE: ./src/plugins/globalRegist.js







/* harmony default export */ var globalRegist = ({
    install: function install(Vue) {
        // 全局注册插件
        keys_default()(plugins_global).forEach(function (key) {
            Vue.use(plugins_global[key]);
        });

        // 全局注册组件
        keys_default()(components_global).forEach(function (key) {
            Vue.component(key, components_global[key]);
        });

        // 全局注册过滤器
        keys_default()(global).forEach(function (key) {
            // console.log(key, filters[key]);
            Vue.filter(key, global[key]);
        });

        // 全局注册指令
        keys_default()(directives_global).forEach(function (key) {
            Vue.directive(key, directives_global[key]);
        });

        // 全局注册mixin
        keys_default()(mixin_global).forEach(function (mixin) {
            Vue.mixin(mixin_global[mixin]);
        });
    }
});
// EXTERNAL MODULE: ./node_modules/fastclick/lib/fastclick.js
var fastclick = __webpack_require__("v5o6");
var fastclick_default = /*#__PURE__*/__webpack_require__.n(fastclick);

// EXTERNAL MODULE: ./node_modules/lib-flexible/flexible.js
var flexible = __webpack_require__("sVYa");
var flexible_default = /*#__PURE__*/__webpack_require__.n(flexible);

// EXTERNAL MODULE: ./node_modules/vconsole/dist/vconsole.min.js
var vconsole_min = __webpack_require__("Lw6n");
var vconsole_min_default = /*#__PURE__*/__webpack_require__.n(vconsole_min);

// CONCATENATED MODULE: ./src/main.js




var main__this = this;

















vue_esm["a" /* default */].use(globalRegist);
vue_esm["a" /* default */].config.silent = true;
vue_esm["a" /* default */].config.productionTip = false;
app_config["a" /* default */].getConfig().then(function (d) {
    assign_default()(src_config_config, d);
    vue_esm["a" /* default */].prototype.$config = src_config_config;
    router.beforeEach(function () {
        var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(to, from, next) {
            var loginInfo, is_vconsole, vConsole;
            return regenerator_default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            loginInfo = JSON.parse(window.dsBridge.call('getLoginMsg') || '{}');

                            src_lang["a" /* default */].locale = loginInfo.langType || cookie["a" /* default */].get("lang") || 'en-US';
                            // 初始化vconsole
                            is_vconsole = localStorage.getItem('vconsole');

                            if (is_vconsole && is_vconsole === 'true') {
                                vConsole = new vconsole_min_default.a();

                                vue_esm["a" /* default */].use(vConsole);
                            }

                            /*
                            * 取消上一页面的网络请求
                            * */
                            /*(window._axiosPromiseArr || []).forEach((ele, index) => {
                                ele.cancel();
                                delete window._axiosPromiseArr[index];
                            });*/

                            /*if(navigator.onLine) {
                                next();
                            } else {
                                next(false);
                                router.push({
                                    name: 'net-error'
                                });
                            }*/
                            try {
                                next();
                            } catch (error) {
                                next(error);
                            }

                        case 5:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, main__this);
        }));

        return function (_x, _x2, _x3) {
            return _ref.apply(this, arguments);
        };
    }());

    router.afterEach(function (to, from) {});

    /*
    * 如果路由加载时出现 Loading chunk xx failed 错误时重新加载当前路由
    * */
    router.onError(function (error) {
        var regx = /Loading chunk (\d)+ failed/g;
        var isChunkLoadFailed = error.message.match(regx);
        var targetPath = router.history.pending.fullPath;
        if (isChunkLoadFailed) {
            ;;
            router.replace(targetPath);
        }
    });

    fastclick_default.a.attach(document.body);

    new vue_esm["a" /* default */]({
        store: src_store,
        i18n: src_lang["a" /* default */],
        router: router,
        render: function render(h) {
            return h(src_App);
        }
    }).$mount('#app-box');
}, function (err) {});

/***/ }),

/***/ "PBVh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TQ26":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UNGY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/vux/src/components/icon/index.vue + 3 modules
var icon = __webpack_require__("oWtu");

// EXTERNAL MODULE: ./node_modules/vux/src/components/datetime/datetimepicker.js + 7 modules
var datetimepicker = __webpack_require__("zV4+");

// EXTERNAL MODULE: ./node_modules/vux/src/components/group/index.vue + 3 modules
var group = __webpack_require__("rHil");

// EXTERNAL MODULE: ./node_modules/vux/src/components/inline-desc/index.vue + 3 modules
var inline_desc = __webpack_require__("kbG3");

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/uuid.js
var uuid = __webpack_require__("KRg4");

// EXTERNAL MODULE: ./node_modules/vux/src/tools/date/format.js
var date_format = __webpack_require__("ODCk");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/datetime/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var datetime = ({
  name: 'datetime',
  mixins: [uuid["a" /* default */]],
  components: {
    Group: group["a" /* default */],
    InlineDesc: inline_desc["a" /* default */],
    Icon: icon["a" /* default */]
  },
  props: {
    format: {
      type: String,
      default: 'YYYY-MM-DD',
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          return console.error('[VUX] Datetime prop:format 使用 A 时只允许的值为： YYYY-MM-DD A');
        }
        return true;
      }
    },
    title: String,
    value: {
      type: String,
      default: ''
    },
    inlineDesc: String,
    placeholder: String,
    minYear: Number,
    maxYear: Number,
    confirmText: String,
    cancelText: String,
    clearText: String,
    yearRow: {
      type: String,
      default: '{value}'
    },
    monthRow: {
      type: String,
      default: '{value}'
    },
    dayRow: {
      type: String,
      default: '{value}'
    },
    hourRow: {
      type: String,
      default: '{value}'
    },
    minuteRow: {
      type: String,
      default: '{value}'
    },
    required: {
      type: Boolean,
      default: false
    },
    minHour: {
      type: Number,
      default: 0
    },
    maxHour: {
      type: Number,
      default: 23
    },
    startDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:start-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    endDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:end-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    valueTextAlign: String,
    displayFormat: Function,
    readonly: Boolean,
    hourList: Array,
    minuteList: Array,
    show: Boolean,
    defaultSelectedValue: String,
    computeHoursFunction: Function,
    computeDaysFunction: Function,
    orderMap: Object
  },
  created: function created() {
    this.isFirstSetValue = false;
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentShow: false,
      currentValue: null,
      valid: true,
      errors: {}
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    var uuid = this.uuid;
    this.$el.setAttribute('id', 'vux-datetime-' + uuid);
    if (!this.readonly) {
      this.$nextTick(function () {
        _this2.render();

        if (_this2.show) {
          _this2.$nextTick(function () {
            _this2.picker && _this2.picker.show(_this2.currentValue);
          });
        }
      });
    }
  },

  computed: {
    styles: function styles() {
      if (!this.$parent) {
        return {};
      }
      return {
        width: this.$parent.labelWidth,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    pickerOptions: function pickerOptions() {
      var _this = this;
      var options = {
        trigger: '#vux-datetime-' + this.uuid,
        format: this.format,
        value: this.currentValue,
        output: '.vux-datetime-value',
        confirmText: _this.getButtonText('confirm'),
        cancelText: _this.getButtonText('cancel'),
        clearText: _this.clearText,
        yearRow: this.yearRow,
        monthRow: this.monthRow,
        dayRow: this.dayRow,
        hourRow: this.hourRow,
        minuteRow: this.minuteRow,
        minHour: this.minHour,
        maxHour: this.maxHour,
        startDate: this.startDate,
        endDate: this.endDate,
        hourList: this.hourList,
        minuteList: this.minuteList,
        defaultSelectedValue: this.defaultSelectedValue,
        computeHoursFunction: this.computeHoursFunction,
        computeDaysFunction: this.computeDaysFunction,
        orderMap: this.orderMap || {},
        onSelect: function onSelect(type, val, wholeValue) {
          if (_this.picker && _this.picker.config.renderInline) {
            _this.$emit('input', wholeValue);
            _this.$emit('on-change', wholeValue);
          }
        },
        onConfirm: function onConfirm(value) {
          _this.currentValue = value;
        },
        onClear: function onClear(value) {
          _this.$emit('on-clear', value);
        },
        onHide: function onHide(type) {
          _this.currentShow = false;
          _this.$emit('update:show', false);
          _this.validate();
          _this.$emit('on-hide', type);
          if (type === 'cancel') {
            _this.$emit('on-cancel');
          }
          if (type === 'confirm') {
            setTimeout(function () {
              _this.$nextTick(function () {
                _this.$emit('on-confirm', _this.value);
              });
            });
          }
        },
        onShow: function onShow() {
          _this.currentShow = true;
          _this.$emit('update:show', true);
          _this.$emit('on-show');
        }
      };
      if (this.minYear) {
        options.minYear = this.minYear;
      }
      if (this.maxYear) {
        options.maxYear = this.maxYear;
      }
      return options;
    },
    firstError: function firstError() {
      var key = keys_default()(this.errors)[0];
      return this.errors[key];
    },
    labelClass: function labelClass() {
      if (!this.$parent) {
        return {};
      }
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    getButtonText: function getButtonText(type) {
      if (type === 'cancel' && this.cancelText) {
        return this.cancelText;
      } else if (type === 'confirm' && this.confirmText) {
        return this.confirmText;
      }
      return this.$el.getAttribute('data-' + type + '-text');
    },
    render: function render() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.picker && _this3.picker.destroy();
        _this3.picker = new datetimepicker["a" /* default */](_this3.pickerOptions);
      });
    },
    validate: function validate() {
      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填';
        return;
      }
      this.valid = true;
      this.errors = {};
    }
  },
  watch: {
    readonly: function readonly(val) {
      if (val) {
        this.picker && this.picker.destroy();
      } else {
        this.render();
      }
    },
    show: function show(val) {
      if (val === this.currentShow) return;
      if (val) {
        this.picker && this.picker.show(this.currentValue);
      } else {
        this.picker && this.picker.hide(this.currentValue);
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      if (!this.isFirstSetValue) {
        this.isFirstSetValue = true;
        oldVal && this.$emit('on-change', val);
      } else {
        this.$emit('on-change', val);
      }
      this.validate();
    },
    startDate: function startDate() {
      this.render();
    },
    endDate: function endDate() {
      this.render();
    },
    format: function format(val) {
      if (this.currentValue) {
        this.currentValue = Object(date_format["a" /* default */])(this.currentValue, val);
      }
      this.render();
    },
    value: function value(val) {
      // do not force render when renderInline is true
      if (this.readonly || this.picker && this.picker.config.renderInline) {
        this.currentValue = val;
        return;
      }
      if (this.currentValue !== val) {
        this.currentValue = val;
        this.render();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.picker && this.picker.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/datetime/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var components_datetime = ({
  name: 'datetime',
  mixins: [uuid["a" /* default */]],
  components: {
    Group: group["a" /* default */],
    InlineDesc: inline_desc["a" /* default */],
    Icon: icon["a" /* default */]
  },
  props: {
    format: {
      type: String,
      default: 'YYYY-MM-DD',
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          return console.error('[VUX] Datetime prop:format 使用 A 时只允许的值为： YYYY-MM-DD A');
        }
        return true;
      }
    },
    title: String,
    value: {
      type: String,
      default: ''
    },
    inlineDesc: String,
    placeholder: String,
    minYear: Number,
    maxYear: Number,
    confirmText: String,
    cancelText: String,
    clearText: String,
    yearRow: {
      type: String,
      default: '{value}'
    },
    monthRow: {
      type: String,
      default: '{value}'
    },
    dayRow: {
      type: String,
      default: '{value}'
    },
    hourRow: {
      type: String,
      default: '{value}'
    },
    minuteRow: {
      type: String,
      default: '{value}'
    },
    required: {
      type: Boolean,
      default: false
    },
    minHour: {
      type: Number,
      default: 0
    },
    maxHour: {
      type: Number,
      default: 23
    },
    startDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:start-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    endDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:end-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    valueTextAlign: String,
    displayFormat: Function,
    readonly: Boolean,
    hourList: Array,
    minuteList: Array,
    show: Boolean,
    defaultSelectedValue: String,
    computeHoursFunction: Function,
    computeDaysFunction: Function,
    orderMap: Object
  },
  created: function created() {
    this.isFirstSetValue = false;
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentShow: false,
      currentValue: null,
      valid: true,
      errors: {}
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    var uuid = this.uuid;
    this.$el.setAttribute('id', 'vux-datetime-' + uuid);
    if (!this.readonly) {
      this.$nextTick(function () {
        _this2.render();

        if (_this2.show) {
          _this2.$nextTick(function () {
            _this2.picker && _this2.picker.show(_this2.currentValue);
          });
        }
      });
    }
  },

  computed: {
    styles: function styles() {
      if (!this.$parent) {
        return {};
      }
      return {
        width: this.$parent.labelWidth,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    pickerOptions: function pickerOptions() {
      var _this = this;
      var options = {
        trigger: '#vux-datetime-' + this.uuid,
        format: this.format,
        value: this.currentValue,
        output: '.vux-datetime-value',
        confirmText: _this.getButtonText('confirm'),
        cancelText: _this.getButtonText('cancel'),
        clearText: _this.clearText,
        yearRow: this.yearRow,
        monthRow: this.monthRow,
        dayRow: this.dayRow,
        hourRow: this.hourRow,
        minuteRow: this.minuteRow,
        minHour: this.minHour,
        maxHour: this.maxHour,
        startDate: this.startDate,
        endDate: this.endDate,
        hourList: this.hourList,
        minuteList: this.minuteList,
        defaultSelectedValue: this.defaultSelectedValue,
        computeHoursFunction: this.computeHoursFunction,
        computeDaysFunction: this.computeDaysFunction,
        orderMap: this.orderMap || {},
        onSelect: function onSelect(type, val, wholeValue) {
          if (_this.picker && _this.picker.config.renderInline) {
            _this.$emit('input', wholeValue);
            _this.$emit('on-change', wholeValue);
          }
        },
        onConfirm: function onConfirm(value) {
          _this.currentValue = value;
        },
        onClear: function onClear(value) {
          _this.$emit('on-clear', value);
        },
        onHide: function onHide(type) {
          _this.currentShow = false;
          _this.$emit('update:show', false);
          _this.validate();
          _this.$emit('on-hide', type);
          if (type === 'cancel') {
            _this.$emit('on-cancel');
          }
          if (type === 'confirm') {
            setTimeout(function () {
              _this.$nextTick(function () {
                _this.$emit('on-confirm', _this.value);
              });
            });
          }
        },
        onShow: function onShow() {
          _this.currentShow = true;
          _this.$emit('update:show', true);
          _this.$emit('on-show');
        }
      };
      if (this.minYear) {
        options.minYear = this.minYear;
      }
      if (this.maxYear) {
        options.maxYear = this.maxYear;
      }
      return options;
    },
    firstError: function firstError() {
      var key = keys_default()(this.errors)[0];
      return this.errors[key];
    },
    labelClass: function labelClass() {
      if (!this.$parent) {
        return {};
      }
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    getButtonText: function getButtonText(type) {
      if (type === 'cancel' && this.cancelText) {
        return this.cancelText;
      } else if (type === 'confirm' && this.confirmText) {
        return this.confirmText;
      }
      return this.$el.getAttribute('data-' + type + '-text');
    },
    render: function render() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.picker && _this3.picker.destroy();
        _this3.picker = new datetimepicker["a" /* default */](_this3.pickerOptions);
      });
    },
    validate: function validate() {
      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填';
        return;
      }
      this.valid = true;
      this.errors = {};
    }
  },
  watch: {
    readonly: function readonly(val) {
      if (val) {
        this.picker && this.picker.destroy();
      } else {
        this.render();
      }
    },
    show: function show(val) {
      if (val === this.currentShow) return;
      if (val) {
        this.picker && this.picker.show(this.currentValue);
      } else {
        this.picker && this.picker.hide(this.currentValue);
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      if (!this.isFirstSetValue) {
        this.isFirstSetValue = true;
        oldVal && this.$emit('on-change', val);
      } else {
        this.$emit('on-change', val);
      }
      this.validate();
    },
    startDate: function startDate() {
      this.render();
    },
    endDate: function endDate() {
      this.render();
    },
    format: function format(val) {
      if (this.currentValue) {
        this.currentValue = Object(date_format["a" /* default */])(this.currentValue, val);
      }
      this.render();
    },
    value: function value(val) {
      // do not force render when renderInline is true
      if (this.readonly || this.picker && this.picker.config.renderInline) {
        this.currentValue = val;
        return;
      }
      if (this.currentValue !== val) {
        this.currentValue = val;
        this.render();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.picker && this.picker.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-241efaf4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/datetime/index.vue
var datetime_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"vux-datetime weui-cell",class:{'weui-cell_access': !_vm.readonly},attrs:{"data-cancel-text":'取消',"data-confirm-text":'确定',"href":"javascript:"}},[_vm._t("default",[_c('div',[_vm._t("title",[_c('p',{class:_vm.labelClass,style:(_vm.styles),domProps:{"innerHTML":_vm._s(_vm.title)}})]),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft vux-cell-primary vux-datetime-value",style:({
        textAlign: _vm.valueTextAlign
      })},[(!_vm.currentValue && _vm.placeholder)?_c('span',{staticClass:"vux-cell-placeholder"},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),(_vm.currentValue)?_c('span',{staticClass:"vux-cell-value"},[_vm._v(_vm._s(_vm.displayFormat ? _vm.displayFormat(_vm.currentValue) : _vm.currentValue))]):_vm._e(),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.valid),expression:"!valid"}],staticClass:"vux-input-icon",attrs:{"type":"warn","title":_vm.firstError}})],1)])],2)}
var staticRenderFns = []
var esExports = { render: datetime_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_datetime = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/datetime/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("5h2b")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_datetime,
  src_components_datetime,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var vux_src_components_datetime = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "V1NV":
/***/ (function(module, exports) {

var date = function date(timestamp) {
    var sep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';

    var _date = new Date(timestamp);
    var y = _date.getFullYear();
    var m = _date.getMonth() + 1;
    var d = _date.getDate();
    return "" + y + sep + doubleNum(m) + sep + doubleNum(d);
};
var doubleNum = function doubleNum(n) {
    if (n.length > 2 || n > 100) {
        return n;
    }
    n = parseInt(n);
    return n >= 10 ? "" + n : "0" + n;
};

var time = function time(timestamp) {
    var sep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ":";

    var _date = new Date(timestamp);
    var h = _date.getHours();
    var m = _date.getMinutes();
    var s = _date.getSeconds();
    return doubleNum(h) + sep + doubleNum(m) + sep + doubleNum(s);
};

var dateTime = function dateTime(timestamp) {
    var dateSep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "-";
    var timeSep = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ":";

    return date(timestamp, dateSep) + " " + time(timestamp, timeSep);
};
/**
 * 返回1970年至今的毫秒数
 * @param secs
 * @returns {Date}
 */
var dateWithTimeIntervalSince1970 = function dateWithTimeIntervalSince1970(secs) {
    var timestamp = secs;
    var newDate = new Date();
    newDate.setTime(timestamp);
    return newDate;
};
/**
 * 返回当月最后一天的日期对象
 * @returns {Date}
 */
var getCurrentMonthLastDay = function getCurrentMonthLastDay() {
    var date = new Date();
    var currentMonth = date.getMonth();
    var nextMonth = ++currentMonth;
    var nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
    var oneDay = 1000 * 60 * 60 * 24;
    return new Date(nextMonthFirstDay - oneDay);
};

/**
 *  返回当月剩余的天数
 *  @return 返回date对象
 */
var datedifference = function datedifference(sDate1, sDate2) {
    var dateSpan = void 0,
        iDays = void 0;
    sDate1 = Date.parse(sDate1);
    sDate2 = Date.parse(sDate2);
    dateSpan = sDate2 - sDate1;
    dateSpan = Math.abs(dateSpan);
    iDays = Math.floor(dateSpan / (24 * 3600 * 1000));
    return iDays;
};
// 隐藏手机号中间四位
var hidePhoneNum = function hidePhoneNum(phone) {
    if (String(phone).length === 11) {
        return String(phone).substr(0, 3) + "****" + String(phone).substr(7);
    } else {
        return String(phone);
    }
};

var tel = function tel(_tel) {
    var sep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : " ";

    if (_tel && _tel.length == 11) {
        return [_tel.slice(0, 3), _tel.slice(3, 7), _tel.slice(7, 11)].join(sep);
    } else {
        return _tel;
    }
};

var changeMBFlow = function changeMBFlow(flow) {
    var unit = "";
    var kUnit = 1024.0;
    var kDivisor = 1000.0;
    var flowSize = flow * 1024 * 1024;
    if (flowSize >= kDivisor) {
        flowSize = flowSize / kUnit;
        if (flowSize >= kDivisor) {
            flowSize = flowSize / kUnit;
            if (flowSize >= kDivisor) {
                flowSize = flowSize / kUnit;
                if (flowSize >= kDivisor) {
                    unit = "TB";
                    flowSize = flowSize / kUnit;
                } else {
                    unit = "GB";
                }
            } else {
                unit = "MB";
            }
        } else {
            flowSize = flowSize / kUnit;
            unit = "MB";
        }
    } else {
        flowSize = flowSize / (kUnit * kUnit);
        unit = "MB";
    }

    var flowInt = parseInt(flowSize * 1000);
    return flowInt / 1000.0 + '' + unit;
};
var keepTwodecimalFull = function keepTwodecimalFull(num) {
    //保留两位小数
    var result = parseFloat(num);
    if (isNaN(result)) {
        return "";
    }
    result = Math.round(num * 100) / 100;
    var s_x = result.toString();
    var pos_decimal = s_x.indexOf('.'); //小数点的所索引值

    //当整数时，pos_decimal = -1 自动补0
    if (pos_decimal < 0) {
        pos_decimal = s_x.length;
        s_x += '.';
    }
    while (s_x.length <= pos_decimal + 2) {
        s_x += '0';
    }
    return s_x;
};
var toYuan = function toYuan(money) {
    //分->显示元
    if (money === "") return "";
    var a = parseInt(money) / 100;
    var str = a + '';
    var arr = str.split('.');
    arr[1] = (arr[1] || '') + '00';
    for (var i = 0; i < arr.length; i++) {
        arr[i] = arr[i].replace(/[^0-9\-]/);
    }
    arr[1] = arr[1].substr(0, 2);
    return [arr[0], arr[1]].join('.');
};
module.exports = {
    date: date,
    time: time,
    dateTime: dateTime,
    doubleNum: doubleNum,
    changeMBFlow: changeMBFlow,
    dateWithTimeIntervalSince1970: dateWithTimeIntervalSince1970,
    getCurrentMonthLastDay: getCurrentMonthLastDay,
    datedifference: datedifference,
    hidePhoneNum: hidePhoneNum,
    tel: tel,
    keepTwodecimalFull: keepTwodecimalFull,
    toYuan: toYuan
};

/***/ }),

/***/ "cEaa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./src/lang/en-us.js
// 按页面划分
/* harmony default export */ var en_us = ({
    // 公共页面
    common: {
        detail: 'Detail',
        confirm: 'Confirm',
        cancel: 'Cancel',
        no_data: 'No Data',
        no_data_text: 'Sorry，there is no data to show right now',
        network_error: 'Unexpected error',
        network_error_text: "Sorry, an error has occured and we're working hard to fix the problem.",
        network_contact: 'Contact us',
        network_for_support: " for support",
        refresh: 'Try again'
    },
    pullCom: {
        pull: 'Pull down to refresh.',
        release: 'Release to refresh',
        refresh: 'Loading...'
    },
    index: {
        searchTip: 'Search country or region',
        exclusiveTit: 'Selected for you',
        more: 'More',
        mainlandTit: 'Mainland China packages',
        hkPackageTit: 'Hong Kong (China) packages',
        popularDestTit: 'Popular destinations',
        countryList: {
            cn: 'Mainland China',
            singapore: 'Singapore',
            hk: 'Hong Kong(China)',
            us: 'United States',
            thailand: 'Thailand',
            germany: 'Germany',
            italy: 'Italy',
            more: 'More'
        },
        regionalPackage: 'Regional data packages',
        recommendPackage: 'Popular packages',
        from: 'From',
        guide: 'Guidelines',
        sepcialArea: ' packages',
        lastUpdate: 'Last Update',
        successRefresh: 'Refresh Complete'
    },
    packages: {
        sub_title: {
            us: 'Excluding Guam, Northern Mariana Islands',
            it: 'Including Vatican City, San Marino',
            va: 'Including Italy, San Marino',
            sm: 'Including Italy, Vatican City',
            ma: 'Including Western Sahara',
            eh: 'Including Morocco',
            ch: 'Including Liechtenstein',
            li: 'Including Switzerland',
            fr: 'Including Monaco',
            mc: 'Including France',
            fi: 'Including Aland Islands',
            ax: 'Including Finland',
            gu: 'Including Northern Mariana Islands',
            mp: 'Including Guam'
        },
        unlimited_packages: 'Unlimited packages',
        normal_packages: 'Normal packages',
        multi_region_packages: 'Multi-region packages',
        sale_text: 'SALE',
        high_speed_text: 'high speed data',
        high_speed_text_year: 'high speed/mo',
        periodUnit: {
            day: 'day',
            month: 'month',
            hour: 'hour',
            year: 'year'
        },
        periodUnits: {
            day: 'days',
            month: 'months',
            hour: 'hours',
            year: 'years'
        },
        periodUnitSimp: {
            day: 'd',
            month: 'mo',
            hour: 'h',
            year: 'yr'
        },
        periodUnitsSimp: {
            day: 'd',
            month: 'mo',
            hour: 'h',
            year: 'yr'
        },
        unlimited_good_name: {
            day: 'Day Pass',
            month: 'Monthly Pass',
            year: 'Yearly Pass'
        },
        day_invalid: 'Expire on the current day',
        month_invalid: 'Expire in the current month',
        immediate_valid: 'Effective from next day',
        tomorrow_day_valid: 'Effective immediately',
        tomorrow_month_valid: 'Effective from next month'
    },
    point: {
        title: 'My points',
        point_history: 'Points History',
        my_point: 'My Points',
        will_expire_on: 'will expire on',
        total: 'Total',
        dataPlans: "Data Plans",
        Balance: 'Balance',
        coupon: 'Coupons',
        more: 'More',
        redeem_for_package: 'Redeem for packages',
        redeem_for_balance: 'Redeem for balance',
        redeem_for_coupon: 'Redeem for coupons',
        points: 'points',
        signIn: "Check In",
        getPoint: "Earn Points",
        lottery: "Points & Rewards",
        getPrizes: "Win Prizes",
        membership_point_rules: 'Membership Point Rules',
        got_it: 'Got it',
        tabs: {
            all: 'All',
            earn: 'Earn',
            redeem: 'Redeem'
        },
        upgradeApp: "Please upgrade to the latest version of APP"
    },
    member: {
        membership: 'Membership',
        hello_member: 'Hello, Member',
        update: 'Update',
        vip_member_benefits: 'VIP Member Benefits',
        packages: 'Packages',
        discounts: 'Discounts',
        points: 'Points',
        membership_policy: 'Membership Policy',
        faq: 'FAQs',
        update_to_vip_membership: 'Update to VIP Membership',
        vip_member: 'VIP Member',
        valid_till: 'Valid till',
        renew: 'Renew',
        months: 'months',
        payment: 'Confirm order',
        vip_membership: 'VIP Membership',
        enjoy_vip_member_benefits: 'Enjoy {len} VIP member benefits!',
        by_purchasing_you_agree_to: 'By purchasing you agree to',
        coupon: 'Coupon',
        available_coupon: '{num} available coupon',
        no_available_coupon: 'No available coupon',
        actual_price: 'Actual Price',
        payment_success_text: 'Corresponding packages will be sent immdiately after payment confirmed.',
        balance: 'Balance',
        online_payment: 'Online Payment',
        faq_title: 'FAQs',
        policy_title: 'Membership Policy',
        introduce_title: 'VIP member benefits',
        total: 'Total'
    },
    order: {
        periodUnit: {
            day: 'day',
            month: 'month',
            year: 'year'
        },
        periodUnits: {
            day: 'days',
            month: 'months',
            year: 'years'
        },
        balance_payment_dialog: {
            title: 'Confirm Payment?',
            content: 'Pay with your account balance',
            noSelectPackageTitle: 'No package selected',
            noSelectPackageContent: 'Please select a package first'
        },
        purcase_successful: 'Update Successful',
        vip_membership: 'VIP Membership',
        total: 'Total',
        finish_btn: 'Done',
        get_order_status: 'Getting order status...',
        order_status_tip: 'Pending',
        order_status_note_user: 'Payment in process...If payment didn\'t get transferred within 10 mins, please contact us for support.',
        order_status_btn_text: 'Done',
        ios_iap_pay_btn: 'Buy now'
    },
    faq: {
        page_title: 'FAQs',
        mydevice: 'My Devices',
        more: 'More Devices',
        more_faq: 'More Questions',
        all_device: 'All Devices',
        faq_detail: 'Details'
    },
    device: {
        page_title: 'Manual'
    },
    vpn: {
        page_title: 'FAQ of VPN',
        faq_detail: 'VPN Details'
    },
    esim: {
        page_title: "ESIM",
        faq_detail: 'ESIM Details'
    },
    deviceGuide: {
        title: 'Please select your device',
        skip: 'Skip'
    },
    give_set: {
        give_set_page_title: 'Complimentary traffic setting',
        give_set_page_set_btn: 'Save',
        title: 'Complimentary package setting for members',
        desc: 'After upgrading to member, we will send the data package to your device on a regular basis except unbound devices!',
        select_device_placeholder: 'Please select the device',
        select_device_title: 'Select the device',
        no_device_title: 'You haven’t bind device yet',
        no_device_desc: 'Please select a device type for binding',
        bind_type_by_scan: 'Scan',
        bind_type_by_type: 'Model',
        disable_device_desc: 'The complimentary traffic packet can\'t be used on the device which you bound. Please bind the corresponding device',
        bind_device: 'Bind device',
        give_set_success: 'Set Successfully',
        give_set_leave_desc: 'Your settings are not saved, are you sure to leave the current page?',
        give_guide_tip: 'Click here to edit complimentary traffic setting!',
        get_it: 'Got it',
        give_set_saved: 'Saved'
    },
    guide: {
        newUser: {
            title: 'Guidelines',
            top_bar: {
                device: 'I want to use the device network',
                sim: 'I want to use the SIM card network'
            },
            step: {
                title: 'How to use the device to access the internet?',
                bind_device: 'Link device',
                buy_package: 'Purchase data',
                use: 'Get started'
            },
            sub_bar: {
                device: 'Device',
                package: 'Data',
                use: 'Start'
            },
            content: {
                device: {
                    list: [{
                        title: 'To link a device:',
                        content: [{
                            text: '1. Link during sign-in, on the [Device Page], or when buying a data plan.',
                            imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-bind-device-img-1@3x.png',
                            desc: '',
                            parentClass: '',
                            class: '',
                            type: 'text'
                        }, {
                            text: '2. Scan the QR code with your smartphone or find it in the device\'s settings.',
                            imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-bind-device-img-2@3x.png',
                            desc: '',
                            parentClass: '',
                            class: '',
                            type: 'text'
                        }, {
                            text: '3. If no QR code, select your device model and follow the instructions.',
                            imgSrc: '',
                            desc: 'Ensure you complete all steps for successful linking.',
                            parentClass: '',
                            class: '',
                            type: 'text'
                        }, {
                            text: 'Ensure you complete all steps for successful linking.',
                            imgSrc: '',
                            desc: 'Ensure you complete all steps for successful linking.',
                            parentClass: '',
                            class: '',
                            type: 'tips'
                        }]
                    }]
                },
                package: {
                    list: [{
                        title: 'To buy a domestic data plan:',
                        content: [{
                            text: '1.Go to [Mall] > [Local Service] on the platform.',
                            imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-buy-package-img-1@3x.png',
                            desc: '',
                            parentClass: '',
                            class: ''
                        }, {
                            text: '2. Select a suitable data plan.',
                            imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-buy-package-img-2@3x.png',
                            desc: '',
                            parentClass: '',
                            class: ''

                        }, {
                            text: '3. Click [Buy] and pay.',
                            imgSrc: '',
                            desc: '',
                            parentClass: '',
                            class: ''

                        }]
                    }, {
                        title: 'To buy an international data plan:',
                        content: [{
                            text: '1.Go to [Home Page].',
                            imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-buy-package-img-1@3x.png',
                            desc: '',
                            parentClass: '',
                            class: ''
                        }, {
                            text: '2.Click on [Search Destination and Data].',
                            imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-buy-package-img-2@3x.png',
                            desc: '',
                            parentClass: '',
                            class: ''

                        }, {
                            text: '3.Enter your destination country or region.',
                            imgSrc: '',
                            desc: '',
                            parentClass: '',
                            class: ''

                        }, {
                            text: '4. Select a data plan based on location, duration, and network type.',
                            imgSrc: '',
                            desc: '',
                            parentClass: '',
                            class: ''

                        }, {
                            text: '5. Click [Buy] and complete the payment.',
                            imgSrc: '',
                            desc: '',
                            parentClass: '',
                            class: ''

                        }, {
                            text: 'Remember to link your device before purchasing a plan',
                            imgSrc: '',
                            desc: '',
                            parentClass: '',
                            class: '',
                            type: 'tips'
                        }]
                    }]
                },
                use: {
                    list: [{
                        title: 'To use the internet:',
                        content: [{
                            text: 'To use the internet:',
                            imgSrc: '',
                            desc: '',
                            parentClass: '',
                            class: ''
                        }, {
                            text: '1. For Local Service(Domestic data plan): Turn on or restart your device to activate it.',
                            imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-net-img-1@3x.png',
                            desc: '',
                            parentClass: '',
                            class: ''
                        }, {
                            text: '2. For Global Service(International data plan): Turn on your device at your destination for automatic activation and internet access once connected to the network.',
                            imgSrc: '',
                            desc: '',
                            parentClass: '',
                            class: ''
                        }, {
                            text: '(It will take 2-3 minutes to connect to the Internet for the first time, please wait patiently)',
                            imgSrc: '',
                            desc: '',
                            parentClass: '',
                            class: '',
                            type: 'tips'
                        }]
                    }]
                },
                sim: {
                    list: [{
                        title: 'How to access the Internet with SIM card?',
                        content: [{
                            text: '1. Insert available SIM card into the device card slot according to the instructions and restart the device for normal operation (For device with screen: you need to switch to SIM card mode on the screen)',
                            imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-use-sim-img-1@3x.png',
                            desc: '',
                            parentClass: '',
                            class: ''
                        }, {
                            text: '2.You can also connect to device WIFI with cellphone. Click SIM function to switch to SIM Mode on your App Detail Page',
                            imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-use-sim-img-2@3x.png',
                            desc: '',
                            parentClass: '',
                            class: ''
                        }]
                    }]
                }
            }
        }
    },
    esimRedmption: {
        hd_title1: 'eSIM',
        hd_title2: 'Redemption',
        weclome_text: 'Please Input your email and redemption code to get your eSIM DATAPackage. Once the eSIM QR code received. Please load it onto your phone befor the QR code expiration time.',
        email: ' Your Email',
        email_placeholder: 'We will send the QRCode to your email',
        confirm_mail: 'Confirm Email',
        confirm_mail_placeholder: 'Type the email again to ensure it\'s correct',
        redemption_code: 'Redemption Code',
        redemption_code_placeholder: 'Input the redemption code',
        captcha_code: 'Captcha Code',
        captcha_code_placeholder: 'Input the captcha code',
        redeem: 'Redeem',
        not_received: 'Not received email ?',
        resend_email: 'Resend Email.',
        empty_email: 'Please enter your email and confirm email first.',
        email_first: 'Please enter your email first.',
        email_confirm_first: 'Please enter your confirm email first.',
        redemption_code_first: 'Please enter your redemption code first.',
        captcha_code_first: 'Please enter your captcha code first.',
        resend_Success: 'The mail will be delivered within 2 hours.',
        system_busy: 'System is busy, please try again later.',
        resend_failed: 'Resend Failed',
        redeem_failed: 'Redeem Failed',
        resend_success_title: 'Resend Success',
        redeem_success: 'Redemption successful',
        redeem_success_title: 'Redemption successful',
        failed: 'Redemption failed'
    }
});
// CONCATENATED MODULE: ./src/lang/zh-cn.js
// 按页面划分
/* harmony default export */ var zh_cn = ({
    // 公共页面
    common: {
        detail: '详情',
        confirm: '确定',
        cancel: '取消',
        no_data: '暂无数据',
        no_data_text: '目前没有可展示的数据',
        network_error: '发生错误',
        network_error_text: '我们正在努力解决，请稍后重试。',
        network_contact: '联系我们',
        refresh: '刷新'
    },
    pullCom: {
        pull: '下拉可以刷新',
        release: '释放立即刷新',
        refresh: '正在刷新...'
    },
    index: {
        searchTip: '搜索国家/地区',
        exclusiveTit: '专属优惠',
        more: '更多',
        mainlandTit: '中国内地专区',
        hkPackageTit: '中国香港专区',
        popularDestTit: '热门目的地',
        countryList: {
            cn: '中国内地',
            singapore: '新加坡',
            hk: '中国香港',
            us: '美国',
            thailand: '泰国',
            germany: '德国',
            italy: '意大利',
            more: '更多'
        },
        regionalPackage: '跨区域流量',
        recommendPackage: '为您推荐',
        from: '起',
        guide: '新手指引',
        sepcialArea: '专区',
        lastUpdate: '上次更新',
        successRefresh: '刷新完成'
    },
    packages: {
        sub_title: {
            us: '不含关岛、塞班岛',
            it: '适用梵蒂冈、圣马力诺',
            va: '适用意大利、圣马力诺',
            sm: '适用意大利、梵蒂冈',
            ma: '适用西撒哈拉',
            eh: '适用摩洛哥',
            ch: '适用列支敦士登',
            li: '适用瑞士',
            fr: '适用摩纳哥',
            mc: '适用法国',
            fi: '适用奥兰群岛',
            ax: '适用芬兰',
            gu: '适用塞班岛',
            mp: '适用关岛'
        },
        unlimited_packages: '畅享包',
        normal_packages: '普通包',
        multi_region_packages: '含{area}的跨区域包',
        sale_text: '优惠',
        high_speed_text: '高速流量',
        high_speed_text_year: '高速流量/月',
        periodUnit: {
            day: '天',
            month: '月',
            hour: '小时',
            year: '年'
        },
        periodUnits: {
            day: '天',
            month: '个月',
            hour: '小时',
            year: '年'
        },
        periodUnitSimp: {
            day: '天',
            month: '月',
            hour: '小时',
            year: '年'
        },
        periodUnitsSimp: {
            day: '天',
            month: '个月',
            hour: '小时',
            year: '年'
        },
        unlimited_good_name: {
            day: '包天畅享',
            month: '月畅享',
            year: '年畅享'
        },
        day_invalid: '当天失效',
        month_invalid: '当月失效',
        immediate_valid: '即时生效',
        tomorrow_day_valid: '次日生效',
        tomorrow_month_valid: '次月生效'
    },
    point: {
        title: '我的积分',
        point_history: '积分明细',
        my_point: '我的积分',
        will_expire_on: '积分有效期至',
        total: '总共',
        more: '更多',
        dataPlans: "兑换流量",
        Balance: '兑换余额',
        coupon: '兑换优惠券',
        redeem_for_package: '兑换流量',
        redeem_for_balance: '兑换余额',
        redeem_for_coupon: '兑换优惠券',
        points: '积分',
        signIn: "签到",
        getPoint: "",
        lottery: "生活商城",
        getPrizes: "",
        membership_point_rules: '会员积分使用说明',
        got_it: '知道了',
        tabs: {
            all: '全部',
            earn: '获得',
            redeem: '兑换'
        },
        upgradeApp: "请升级最新版APP"
    },
    member: {
        membership: '会员',
        hello_member: '你好, 会员',
        update: '升级',
        vip_member_benefits: 'VIP会员权益',
        packages: '流量包',
        discounts: '折扣',
        points: '积分',
        membership_policy: '会员协议',
        faq: '常见问题',
        update_to_vip_membership: '升级至VIP会员',
        vip_member: 'VIP会员',
        valid_till: '有效期至',
        renew: '续费',
        months: '个月',
        payment: '支付订单',
        vip_membership: 'VIP会员',
        enjoy_vip_member_benefits: '尊享{len}大VIP会员权益！',
        by_purchasing_you_agree_to: '购买即代表同意',
        coupon: '优惠',
        available_coupon: '{num}个可用',
        no_available_coupon: '暂无优惠',
        actual_price: '实付金额',
        payment_success_text: '购买成功后，相关流量包即可自动到账。',
        balance: '余额',
        online_payment: '在线支付',
        faq_title: '常见问题',
        policy_title: '会员隐私',
        introduce_title: '会员介绍'
    },
    order: {
        periodUnit: {
            day: '天',
            month: '个月',
            year: '年'
        },
        periodUnits: {
            day: '天',
            month: '个月',
            year: '年'
        },
        balance_payment_dialog: {
            title: '确定支付吗？',
            content: '您将使用余额支付',
            noSelectPackageTitle: '未选择套餐',
            noSelectPackageContent: '请先选择一个套餐'

        },
        purcase_successful: '购买成功',
        vip_membership: 'VIP会员',
        total: '支付金额',
        finish_btn: '返回',
        get_order_status: '正在努力获取订单状态...',
        order_status_tip: '支付待确认',
        order_status_note_user: '支付结果确认中，如10分钟后还未到账，请咨询客服。',
        order_status_btn_text: '完成',
        ios_iap_pay_btn: '立即支付'
    },
    faq: {
        page_title: '常见问题',
        mydevice: '我的设备',
        more: '更多设备',
        more_faq: '更多问题',
        all_device: '全部设备',
        faq_detail: '详情'
    },
    device: {
        page_title: '设备手册'
    },
    vpn: {
        page_title: 'VPN常见问题',
        faq_detail: '详情'
    },
    esim: {
        page_title: "ESIM常见问题",
        faq_detail: 'esim详情'
    },
    deviceGuide: {
        title: '请选择你的设备',
        skip: '跳过'
    },
    give_set: {
        give_set_page_title: '赠送流量设置',
        give_set_page_set_btn: '保存',
        title: '会员赠送套餐设置',
        desc: '升级会员成功后，我们将会定期赠送流量包至您设置的设备上，未绑定设备将不能接收赠送流量包！',
        select_device_placeholder: '请选择设备',
        select_device_title: '选择设备',
        no_device_title: '你还未绑定设备',
        no_device_desc: '请选择绑定设备类型',
        bind_type_by_scan: '扫一扫',
        bind_type_by_type: '按类型',
        disable_device_desc: '赠送流量包无法在您绑定的设备上使用，请绑定对应的设备',
        bind_device: '绑定设备',
        give_set_success: '设置成功',
        give_set_leave_desc: '当前设置未保存，确定离开当前页面吗？',
        give_guide_tip: '点击这里可编辑赠送流量设置哦！',
        get_it: '知道了',
        give_set_saved: '保存成功'
    },
    guide: {
        newUser: {
            title: '新手指引',
            top_bar: {
                device: '我要使用设备网络',
                sim: '我要使用SIM卡网络'
            },
            step: {
                title: '如何使用设备上网',
                bind_device: '绑定设备',
                buy_package: '购买流量',
                use: '开机使用'
            },
            sub_bar: {
                device: '设备',
                package: '流量',
                use: '使用'
            },
            content: {
                device: {
                    list: [{
                        title: '如何绑定设备？',
                        content: [{
                            text: '1、用户可在首次登录/注册时绑定设备，或者前往【设备】绑定，或者在购买流量包时进行绑定。',
                            imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-bind-device-img-1@3x.png',
                            desc: '',
                            parentClass: '',
                            class: ''
                        }, {
                            text: '2、绑定方法可以通过【扫码绑定】，直接扫一扫设备背面的二维码，有屏设备在【屏幕首页】-【更多设置】中查看。或通过【按型号绑定】，选择具体设备型号，依据指引进行绑定。',
                            imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-bind-device-img-2@3x.png',
                            desc: '',
                            parentClass: '',
                            class: ''
                        }]
                    }]
                },
                package: {
                    list: [{
                        title: '如何购买国内流量包？',
                        content: [{
                            text: '1、前往【商城】-【本地服务】，浏览商品信息。',
                            imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-buy-package-img-1@3x.png',
                            desc: '',
                            parentClass: '',
                            class: ''
                        }, {
                            text: '2、点击【购买】，然后完成支付。如当前还未绑定设备，请先绑定设备后再购买流量。',
                            imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-buy-package-img-2@3x.png',
                            desc: '',
                            parentClass: '',
                            class: ''

                        }]
                    }, {
                        title: '如何购买境外流量包？',
                        content: [{
                            text: '1、前往【首页】，点击【搜索目的地和流量】，输入准备前往的目的地。您可以根据需要灵活选择流量，单一国家、区域或全球流量，包天、7天或30天，5G或4G。',
                            imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-buy-package-img-1@3x.png',
                            desc: '',
                            parentClass: '',
                            class: ''
                        }, {
                            text: '2、点击【购买】，然后完成支付。如当前还未绑定设备，请先绑定设备后再购买流量。',
                            imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-buy-package-img-2@3x.png',
                            desc: '',
                            parentClass: '',
                            class: ''

                        }]
                    }]
                },
                use: {
                    list: [{
                        title: '如何开始上网？',
                        content: [{
                            text: '1、购买国内（本地服务）流量包后，开启设备将自动激活流量包，已开启的设备需重新启动。',
                            imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-net-img-1@3x.png',
                            desc: '',
                            parentClass: '',
                            class: ''
                        }, {
                            text: '2、购买境外（全球服务）流量包后，在目的地开启设备将自动激活流量包，设备成功连网后即可自由上网。',
                            imgSrc: '',
                            desc: '',
                            parentClass: '',
                            class: ''
                        }, {
                            text: '（设备第一次连网时间大概需要2-3分钟，请耐心等待）',
                            imgSrc: '',
                            desc: '',
                            parentClass: '',
                            class: '',
                            type: 'tips'
                        }]
                    }]
                },
                sim: {
                    list: [{
                        title: '如何使用SIM卡上网？',
                        content: [{
                            text: '1、按照说明书指引，将可用SIM卡插入设备卡槽后再重启设备，即可正常使用（有屏设备需在设备屏幕上切换至SIM卡模式）。',
                            imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-use-sim-img-1@3x.png',
                            desc: '',
                            parentClass: '',
                            class: ''
                        }, {
                            text: '2、您还可以用手机连接设备的Wi-Fi，在App设备详情页，点击SIM功能切换至SIM模式。',
                            imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-use-sim-img-2@3x.png',
                            desc: '',
                            parentClass: '',
                            class: ''
                        }]
                    }]
                }
            }
        }
    },
    esimRedmption: {
        hd_title1: 'eSIM',
        hd_title2: '兑换',
        weclome_text: '请输入您的邮箱和兑换码以获取eSIM流量包，我们会把二维码发送到您的邮箱。收到eSIM二维码后，请在二维码失效时间前将其加载到您的手机上。',
        email: '您的邮箱',
        email_placeholder: '我们将把二维码发送到您的邮箱',
        confirm_mail: '确认邮箱',
        confirm_mail_placeholder: '再次输入邮箱以确保正确无误',
        redemption_code: '兑换码',
        redemption_code_placeholder: '请输入兑换码',
        captcha_code: '验证码',
        captcha_code_placeholder: '请输入验证码兑换',
        redeem: '兑换',
        redeem_success: '兑换成功',
        redeem_success_title: '兑换成功',
        failed: '兑换失败',
        not_received: '未收到邮件？',
        resend_email: '请重新发送邮件',
        empty_email: '请先输入邮箱和确认邮箱',
        email_first: '请先输入邮箱',
        email_confirm_first: '请先输入确认邮箱',
        redemption_code_first: '请先输入兑换码',
        captcha_code_first: '请先输入验证码',
        resend_Success: '邮件将在2小时内发送',
        system_busy: '系统繁忙，请稍后重试',
        resend_failed: '重发失败',
        redeem_failed: '兑换失败',
        resend_success_title: '重发成功'
    }
});
// CONCATENATED MODULE: ./src/lang/zh-TW.js
// 按页面划分
/* harmony default export */ var zh_TW = ({
    // 公共页面
    common: {
        detail: '詳情',
        confirm: '確定',
        cancel: '取消',
        no_data: '暫無數據',
        no_data_text: '目前沒有可展示的數據',
        network_error: '發生錯誤',
        network_error_text: '我們正在努力解決，請稍後重試。',
        network_contact: '聯系我們',
        refresh: '刷新'
    },
    pullCom: {
        pull: '下拉可以刷新',
        release: '释放立即刷新',
        refresh: '正在刷新...'
    },
    index: {
        searchTip: '搜索國家/地區',
        exclusiveTit: '專屬優惠',
        more: '更多',
        mainlandTit: '中國內地專區',
        hkPackageTit: '中國香港專區',
        popularDestTit: '熱門目的地',
        countryList: {
            cn: '中国内地',
            singapore: '新加坡',
            hk: '中国香港',
            us: '美国',
            thailand: '泰国',
            germany: '德国',
            italy: '意大利',
            more: '更多'
        },
        regionalPackage: '跨區域流量',
        recommendPackage: '為您推薦',
        from: '起',
        guide: '新手指引',
        sepcialArea: '專區',
        lastUpdate: '上次更新',
        successRefresh: '刷新完成'
    },
    packages: {
        sub_title: {
            us: '不含關島、塞班島',
            it: '適用梵蒂岡、聖馬力諾',
            va: '適用意大利、聖馬力諾',
            sm: '適用意大利、梵蒂岡',
            ma: '適用西撒哈拉',
            eh: '適用摩洛哥',
            ch: '適用列支敦士登',
            li: '適用瑞士',
            fr: '適用摩納哥',
            mc: '適用法國',
            fi: '適用奧蘭群島',
            ax: '適用芬蘭',
            gu: '適用塞班島',
            mp: '適用關島'
        },
        unlimited_packages: '暢享包',
        normal_packages: '普通包',
        multi_region_packages: '含{area}的跨區域包',
        sale_text: '優惠',
        high_speed_text: '高速流量',
        high_speed_text_year: '高速流量/月',
        periodUnit: {
            day: '天',
            month: '月',
            hour: '小時',
            year: '年'
        },
        periodUnits: {
            day: '天',
            month: '個月',
            hour: '小時',
            year: '年'
        },
        periodUnitSimp: {
            day: '天',
            month: '月',
            hour: '小時',
            year: '年'
        },
        periodUnitsSimp: {
            day: '天',
            month: '個月',
            hour: '小時',
            year: '年'
        },
        unlimited_good_name: {
            day: '包天暢享',
            month: '月畅享',
            year: '年畅享'
        },
        day_invalid: '當天失效',
        month_invalid: '當月失效',
        immediate_valid: '即時生效',
        tomorrow_day_valid: '次日生效',
        tomorrow_month_valid: '次月生效'
    },
    point: {
        title: '我的積分',
        point_history: '積分明細',
        my_point: '我的積分',
        will_expire_on: '積分有效期至',
        total: '總共',
        more: '更多',
        redeem_for_package: '兌換流量',
        redeem_for_balance: '兌換餘額',
        redeem_for_coupon: '兌換優惠券',
        points: '積分',
        dataPlans: "兌換流量",
        Balance: "兌換餘額",
        coupon: "兌換優惠券",
        signIn: "簽到",
        getPoint: "領積分",
        lottery: "积分 & 奖励",
        getPrizes: "贏禮品",
        membership_point_rules: '會員積分使用說明',
        got_it: '知道了',
        tabs: {
            all: '全部',
            earn: '獲得',
            redeem: '兌換'
        },
        upgradeApp: "請升級最新版APP"
    },
    member: {
        membership: '會員',
        hello_member: '你好, 會員',
        update: '升級',
        vip_member_benefits: 'VIP會員權益',
        packages: '流量包',
        discounts: '折扣',
        points: '積分',
        membership_policy: '會員協議',
        faq: '常見問題',
        update_to_vip_membership: '升級至VIP會員',
        vip_member: 'VIP會員',
        valid_till: '有效期至',
        renew: '續費',
        months: '個月',
        payment: '支付訂單',
        vip_membership: 'VIP會員',
        enjoy_vip_member_benefits: '尊享{len}大VIP會員權益！',
        by_purchasing_you_agree_to: '購買即代表同意',
        coupon: '優惠',
        available_coupon: '{num}個可用',
        no_available_coupon: '暫無優惠',
        actual_price: '實付金額',
        payment_success_text: '購買成功后，相關流量包即可自動到賬。',
        balance: '餘額',
        online_payment: '在線支付',
        faq_title: '常見問題',
        policy_title: '會員隱私',
        introduce_title: '會員介紹'
    },
    order: {
        periodUnit: {
            day: '天',
            month: '個月',
            year: '年'
        },
        periodUnits: {
            day: '天',
            month: '個月',
            year: '年'
        },
        balance_payment_dialog: {
            title: '確定支付嗎？',
            content: '您將使用餘額支付',
            noSelectPackageTitle: '未選擇套餐',
            noSelectPackageContent: '請先選擇一個套餐'
        },
        purcase_successful: '購買成功',
        vip_membership: 'VIP會員',
        total: '支付金額',
        finish_btn: '返回',
        get_order_status: '正在努力獲取訂單狀態...',
        order_status_tip: '支付待確認',
        order_status_note_user: '支付結果確認中，如10分鐘后還未到賬，請咨詢客服。',
        order_status_btn_text: '完成',
        ios_iap_pay_btn: '立即支付'
    },
    faq: {
        page_title: '常見問題',
        mydevice: '我的設備',
        more: '更多設備',
        more_faq: '更多問題',
        all_device: '全部設備',
        faq_detail: '詳情'
    },
    device: {
        page_title: '設備手冊'
    },
    vpn: {
        page_title: 'VPN常見問題',
        faq_detail: '詳情'
    },
    esim: {
        page_title: "ESIM常見問題",
        faq_detail: 'ESIM詳情'
    },
    deviceGuide: {
        title: '請選擇你的設備',
        skip: '跳過'
    },
    give_set: {
        give_set_page_title: '贈送流量設置',
        give_set_page_set_btn: '儲存',
        title: '會員贈送套餐設置',
        desc: '升級會員成功後我們將會定期贈送流量包至您設置的設備上，未綁定設備將不能接收贈送流量包！',
        select_device_placeholder: '請選擇設備',
        select_device_title: '選擇設備',
        no_device_title: '你還未綁定設備',
        no_device_desc: '請選擇綁定設備類型',
        bind_type_by_scan: '掃描',
        bind_type_by_type: '按類型',
        disable_device_desc: '贈送流量包無法在您綁定的設備上使用，請綁定對應的設備',
        bind_device: '綁定設備',
        give_set_success: '設定成功',
        give_set_leave_desc: '當前設置未保存，確定離開當前頁面嗎？',
        give_guide_tip: '點擊這裡可編輯贈送流量設置哦！',
        get_it: '知道了',
        give_set_saved: '保存成功'
    },
    guide: {
        newUser: {
            title: '新手指引',
            top_bar: {
                device: '我要使用設備網絡',
                sim: '我要使用SIM卡網絡'
            },
            step: {
                title: '如何使用設備上網',
                bind_device: '綁定設備',
                buy_package: '購買流量',
                use: '開機使用'
            },
            sub_bar: {
                device: '設備',
                package: '流量',
                use: '使用'
            },
            content: {
                device: {
                    list: [{
                        title: '如何綁定設備？',
                        content: [{
                            text: '用戶可在首次登入時綁定設備，或前往「設備」綁定，或在購買服務計劃時進行綁定。',
                            imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-bind-device-img-1@3x.png',
                            desc: '',
                            parentClass: '',
                            class: ''
                        }, {
                            text: '2. 綁定方法可以透過「掃碼綁定」，直接掃一掃設備背面的QR碼，有屏設備在「屏幕首頁」-「更多設定」中查看。或透過「依型號綁定」，選擇你的設備類型，依據指引進行綁定。',
                            imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-bind-device-img-2@3x.png',
                            desc: '',
                            parentClass: '',
                            class: ''
                        }]
                    }]
                },
                package: {
                    list: [{
                        title: '如何購買本地流動數據計劃？',
                        content: [{
                            text: '1、前往「商城」-「本地服務」，瀏覽商品資訊。',
                            imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-buy-package-img-1@3x.png',
                            desc: '',
                            parentClass: '',
                            class: ''
                        }, {
                            text: '2、點選「購買」，然後完成付款。如目前還未綁定設備，請先綁定設備後再購買服務計劃。',
                            imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-buy-package-img-2@3x.png',
                            desc: '',
                            parentClass: '',
                            class: ''

                        }]
                    }, {
                        title: '如何購買全球流動數據計劃？',
                        content: [{
                            text: '1、前往「首頁」，點選「搜尋目的地與流量」，輸入準備前往的目的地。您可以根據需要靈活選擇服務計劃，單一國家、區域或全球流量，包天、7天或30天，5G或4G。',
                            imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-buy-package-img-1@3x.png',
                            desc: '',
                            parentClass: '',
                            class: ''
                        }, {
                            text: '2、點選「購買」，然後完成付款。如目前還未綁定設備，請先綁定設備後再購買服務計劃。',
                            imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-buy-package-img-2@3x.png',
                            desc: '',
                            parentClass: '',
                            class: ''

                        }]
                    }]
                },
                use: {
                    list: [{
                        title: '如何開始上網？',
                        content: [{
                            text: '1、購買本地服務計劃後，開啟設備將自動啟動服務計劃，已開啟的設備需重新啟動。',
                            imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-net-img-1@3x.png',
                            desc: '',
                            parentClass: '',
                            class: ''
                        }, {
                            text: '2、購買全球服務計劃後，在目的地開啟設備將自動啟動服務計劃，設備成功連接互聯網後即可自由上網。',
                            imgSrc: '',
                            desc: '',
                            parentClass: '',
                            class: ''
                        }, {
                            text: '（設備第一次連網時間大概需要2-3分鐘，請耐心等待）',
                            imgSrc: '',
                            desc: '',
                            parentClass: '',
                            class: '',
                            type: 'tips'
                        }]
                    }]
                },
                sim: {
                    list: [{
                        title: '如何使用SIM卡上網？',
                        content: [{
                            text: '1、按照說明書指引，將可用SIM卡插入設備卡槽後再重啟設備，即可正常使用（有屏設備需在設備屏幕上切換至SIM卡模式）',
                            imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-use-sim-img-1@3x.png',
                            desc: '',
                            parentClass: '',
                            class: ''
                        }, {
                            text: '2、您還可以用手機連接設備的Wi-Fi，在App設備詳情頁，點擊SIM功能切換至SIM模式',
                            imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-use-sim-img-2@3x.png',
                            desc: '',
                            parentClass: '',
                            class: ''
                        }]
                    }]
                }
            }
        }
    }
});
// CONCATENATED MODULE: ./src/lang/ja-JP.js
// 按页面划分
/* harmony default export */ var ja_JP = ({
    // 公共页面
    common: {
        detail: '詳細',
        confirm: '確定',
        cancel: 'キャンセル',
        no_data: '利用可能なデータがありません',
        no_data_text: '現在、表示できるデータはありません',
        network_error: 'エラーが発生しました',
        network_error_text: "問題解決のため、修復中です。しばらく経ってから再度お試しください。",
        network_contact: 'お問い合わせ',
        network_for_support: "お問い合わせ",
        refresh: '更新する'
    },
    pullCom: {
        pull: 'スクロールして更新',
        release: '離すと更新',
        refresh: '更新中…'
    },
    index: {
        searchTip: '国/地域を探す',
        exclusiveTit: '専属特典',
        more: 'その他',
        mainlandTit: '中国大陸エリア',
        hkPackageTit: 'Hong Kong (China) packages',
        popularDestTit: 'Popular destinations',
        countryList: {
            cn: 'Mainland China',
            singapore: 'Singapore',
            hk: 'Hong Kong(China)',
            us: 'United States',
            thailand: 'Thailand',
            germany: 'Germany',
            italy: 'Italy',
            more: 'その他'
        },
        regionalPackage: '周遊データ(複数地域含む)',
        recommendPackage: 'おすすめ',
        from: 'から',
        guide: '初心者ガイドライン',
        sepcialArea: 'ご利用エリア',
        lastUpdate: '最終更新',
        successRefresh: '更新完了'
    },
    packages: {
        sub_title: {
            us: 'グアムとサイパンを除く',
            it: 'バチカン市国、サンマリノを含む',
            va: 'イタリア、サンマリノを含む',
            sm: 'イタリア、バチカン市国を含む',
            ma: '西サハラを含む',
            eh: 'モロッコを含む',
            ch: 'リヒテンシュタインを含む',
            li: 'スイスを含むを',
            fr: 'モナコを含む',
            mc: 'フランスを含む',
            fi: 'オーランド諸島を含む',
            ax: 'フィンランドを含む',
            gu: 'サイパンを含む',
            mp: 'グアムを含む'
        },
        unlimited_packages: '無制限のデータプラン',
        normal_packages: 'データパッケージ',
        multi_region_packages: '複数エリア対象パッケージ',
        sale_text: '割引',
        high_speed_text: 'データ',
        high_speed_text_year: '高速通信/月',
        periodUnit: {
            day: '日',
            month: '月',
            hour: '時間',
            year: '年'
        },
        periodUnits: {
            day: '日',
            month: '月',
            hour: '時間',
            year: '年'
        },
        periodUnitSimp: {
            day: '日',
            month: '月',
            hour: '時間',
            year: '年'
        },
        periodUnitsSimp: {
            day: '日',
            month: '月',
            hour: '時間',
            year: '年'
        },
        unlimited_good_name: {
            day: 'Day Pass',
            month: 'Monthly Pass',
            year: 'Yearly Pass'
        },
        day_invalid: '当日失効',
        month_invalid: '当月失効',
        immediate_valid: '即時有効',
        tomorrow_day_valid: '翌日有効',
        tomorrow_month_valid: '翌月有効'
    },
    point: {
        title: 'ポイント',
        point_history: 'ポイント明細',
        my_point: 'ポイント',
        will_expire_on: 'ポイント有効期限',
        total: '合計',
        more: 'その他',
        redeem_for_package: 'データと交換',
        redeem_for_balance: '残高と交換',
        redeem_for_coupon: 'クーポンと交換',
        points: 'ポイント',
        dataPlans: "データと交換",
        Balance: "残高と交換",
        coupon: "クーポンと交換",
        signIn: "チェックイン",
        getPoint: "ポイントを獲得",
        lottery: "ポイントとリワード",
        getPrizes: "賞品を獲得",
        membership_point_rules: '会員ポイントのご利用にあたって',
        got_it: '確認',
        tabs: {
            all: 'すべて',
            earn: '獲得',
            redeem: '取得'
        },
        upgradeApp: "APPを最新バージョンにアップグレードしてください"
    },
    member: {
        membership: 'メンバーシップ',
        hello_member: 'こんにちは、会員様',
        update: 'アップグレード',
        vip_member_benefits: 'VIP会員権',
        packages: 'データプラン/パッケージ',
        discounts: '割引価格',
        points: 'ポイント',
        membership_policy: 'VIP会員規約',
        faq: 'よくある質問',
        update_to_vip_membership: 'VIP会員にアップグレード',
        vip_member: 'VIP会員',
        valid_till: 'まで有効',
        renew: '更新',
        months: '月',
        payment: '支払確認',
        vip_membership: 'VIP会員',
        enjoy_vip_member_benefits: '{len}プレミアムVIP会員特典をお使い頂けます！',
        by_purchasing_you_agree_to: 'ご購入は同意したものと見なされます',
        coupon: '割引',
        available_coupon: '{num}個利用可',
        no_available_coupon: '利用可能なクーポンがありません',
        actual_price: 'お支払い金額',
        payment_success_text: 'ご購入いただいた後、パッケージは自動的に追加されます。',
        balance: '残高',
        online_payment: 'オンライン支払',
        faq_title: 'FAQs',
        policy_title: '会員プライバシー',
        introduce_title: '会員紹介'
    },
    order: {
        periodUnit: {
            day: '日',
            month: '月',
            year: '年'
        },
        periodUnits: {
            day: '日',
            month: '月',
            year: '年'
        },
        balance_payment_dialog: {
            title: '購入を確定',
            content: 'アカウント残高から支払う',
            noSelectPackageTitle: 'プランが選択されていません',
            noSelectPackageContent: 'まずコースをお選びください'
        },
        purcase_successful: '購入成功',
        vip_membership: 'VIP会員',
        total: '支払い金額',
        finish_btn: '戻る',
        get_order_status: '注文内容を確認しています。',
        order_status_tip: '支払い保留',
        order_status_note_user: 'お支払い内容を確認しています。10分以内に完了できない場合は、カスタマーサービスにお問い合わせください。',
        order_status_btn_text: '完了',
        ios_iap_pay_btn: '購入する'
    },
    faq: {
        page_title: 'FAQs',
        mydevice: 'マイデバイス',
        more: '他のデバイス',
        more_faq: 'その他の問題',
        all_device: 'すべてのデバイス',
        faq_detail: '詳細'
    },
    device: {
        page_title: 'ユーザーマニュアル'
    },
    vpn: {
        page_title: 'VPNに関するよくある質問',
        faq_detail: '詳細'
    },
    esim: {
        page_title: 'ESIMに関するよくある質問',
        faq_detail: '詳細'
    },
    deviceGuide: {
        title: 'デバイスを選択してください',
        skip: 'スキップ'
    },
    give_set: {
        give_set_page_title: 'データ送り設定',
        give_set_page_set_btn: '保存',
        title: 'VIPギフトデータパッケージ設定',
        desc: 'VIPをアップグレードすると、設定されたデバイスに定期的にギフトデータパッケージをサービスします。紐付けされていないデバイスでは受信できません。',
        select_device_placeholder: 'デバイスを選択してください',
        select_device_title: 'デバイスを選択する',
        no_device_title: 'デバイスを紐付けしていません。',
        no_device_desc: 'バインディングデバイスのタイプを選択してください',
        bind_type_by_scan: 'スキャン',
        bind_type_by_type: 'モデル',
        disable_device_desc: 'ギフトデータパッケージは紐付けされたデバイスで使用できません。対応するデバイスを紐付けしてください',
        bind_device: 'デバイスを紐づける',
        give_set_success: '設定成功',
        give_set_leave_desc: '現在の設定は保存されません。現在のページを離れてもよろしいですか？',
        give_guide_tip: 'データ送り設定を編集するには、ここをクリックしてください。',
        get_it: '確認',
        give_set_saved: '保存完了'
    },
    guide: {
        newUser: {
            title: '初心者ガイドライン',
            top_bar: {
                device: '端末のインタネットに接続したい',
                sim: 'SIMのインタネットに接続したい'
            },
            step: {
                title: '端末のインターネットにアクセスする方法は何ですか',
                bind_device: 'デバイスを紐づける',
                buy_package: 'データ購入',
                use: '電源を入れて使用します'
            },
            sub_bar: {
                device: 'デバイス',
                package: '容量',
                use: '使用'
            },
            content: {
                device: {
                    list: [{
                        title: 'デバイスをバインドするには：',
                        content: [{
                            text: '1.ログイン時にバインドしてください。或は[デバイスページ]に移動し、またはデータプラン購入時にデバイスをバインドしてください。',
                            imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-bind-device-img-1@3x.png',
                            desc: '',
                            parentClass: '',
                            class: '',
                            type: 'text'
                        }, {
                            text: '2. スマートフォンでQRコードをスキャンするか、デバイスの設定でQRコードを見つけます。',
                            imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-bind-device-img-2@3x.png',
                            desc: '',
                            parentClass: '',
                            class: '',
                            type: 'text'
                        }, {
                            text: '3. QRコードがない場合は、デバイスモデルを選択して指示に従ってください。',
                            imgSrc: '',
                            desc: '',
                            parentClass: '',
                            class: '',
                            type: 'text'
                        }, {
                            text: '全てのステップを完了して、バインドが成功するようにしてください。',
                            imgSrc: '',
                            desc: '',
                            parentClass: '',
                            class: '',
                            type: 'tips'
                        }]
                    }]
                },
                package: {
                    list: [{
                        title: 'ローカルデータプランを購入するには：',
                        content: [{
                            text: '1. アプリで[ストア] > [ローカルサービス]に移動してください。',
                            imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-buy-package-img-1@3x.png',
                            desc: '',
                            parentClass: '',
                            class: ''
                        }, {
                            text: '2. 理想のデータプランを選択してください。',
                            imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-buy-package-img-2@3x.png',
                            desc: '',
                            parentClass: '',
                            class: ''
                        }, {
                            text: '3. [購入]をクリックして支払いを完了してください。',
                            imgSrc: '',
                            desc: '',
                            parentClass: '',
                            class: ''
                        }]
                    }, {
                        title: 'グローバルデータプランを購入するには:',
                        content: [{
                            text: '1. [ホームページ]に移動します。',
                            imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-buy-package-img-1@3x.png',
                            desc: '',
                            parentClass: '',
                            class: ''
                        }, {
                            text: '2. [目的地とデータを検索する]をクリックしてください。',
                            imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-buy-package-img-2@3x.png',
                            desc: '',
                            parentClass: '',
                            class: ''

                        }, {
                            text: '3.目的地の国または地域を入力してください。',
                            imgSrc: '',
                            desc: '',
                            parentClass: '',
                            class: ''

                        }, {
                            text: '4.場所、期間、ネットワークタイプに基づいてデータプランを選択します。',
                            imgSrc: '',
                            desc: '',
                            parentClass: '',
                            class: ''

                        }, {
                            text: '5. [購入]をクリックして支払いを完了してください。',
                            imgSrc: '',
                            desc: '',
                            parentClass: '',
                            class: ''

                        }, {
                            text: 'プランを購入する前にデバイスをバインドしてください。',
                            imgSrc: '',
                            type: 'tips',
                            desc: '',
                            parentClass: '',
                            class: ''

                        }]
                    }]
                },
                use: {
                    list: [{
                        title: 'インターネット接続するには：',
                        content: [{
                            text: 'インターネット接続するには：',
                            imgSrc: '',
                            desc: '',
                            parentClass: '',
                            class: ''
                        }, {
                            text: '1.ローカルサービス「ローカルデータプラン」の場合：デバイスをオンにするか、再起動して有効化してください。',
                            imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-net-img-1@3x.png',
                            desc: '',
                            parentClass: '',
                            class: ''
                        }, {
                            text: '2.グローバルサービス「グローバルデータプラン」の場合：目的地でデバイスをオンにし、ネットワークに接続すると自動的に有効化され、インターネットにアクセスできます。',
                            imgSrc: '',
                            desc: '',
                            parentClass: '',
                            class: ''
                        }, {
                            text: '(初回のインターネット接続には約2～3分かかりますので、しばらくお待ちください。）',
                            imgSrc: '',
                            desc: '',
                            parentClass: '',
                            class: '',
                            type: 'tips'
                        }]
                    }]
                },
                sim: {
                    list: [{
                        title: 'SIMカードを使ってインターネットに接続するにはどうすればいいですか？',
                        content: [{
                            text: '1.取扱説明書に従って、利用可能なSIMカードを端末のスロットに挿入した後、端末を再起動すると正常に利用できます（画面付きの端末は、端末画面でSIMカードモードに切り替える必要があります）。',
                            imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-use-sim-img-1@3x.png',
                            desc: '',
                            parentClass: '',
                            class: ''
                        }, {
                            text: '2、携帯電話で端末のWi-Fiに接続し、Appの端末詳細ページで、SIM機能をクリックして、SIMモードに切り替えることもできます。',
                            imgSrc: 'https://mph5.ucloudlink.cn/appweb/glocalme/app/newuser/how-use-sim-img-2@3x.png',
                            desc: '',
                            parentClass: '',
                            class: ''
                        }]
                    }]
                }
            }
        }
    }
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/lang/fr-FR.js


var _point;

// 按页面划分
/* harmony default export */ var fr_FR = ({
    // 公共页面
    common: {
        detail: 'Détails',
        confirm: 'D\'accord',
        cancel: 'Annuler',
        no_data: 'Aucune donnée disponible',
        no_data_text: 'Il n\'y a actuellement aucune donnée à afficher ',
        network_error: 'Une erreur s\'est produite',
        network_error_text: 'Nous nous efforçons de la résoudre, veuillez réessayer plus tard.',
        network_contact: 'Nous contacter',
        refresh: 'Rafraîchir'
    },
    pullCom: {
        pull: 'Faire glisser pour actualiser',
        release: 'Relâcher pour actualiser',
        refresh: 'Actualisation en cours…'
    },
    index: {
        searchTip: 'Recherche Pays/Région',
        exclusiveTit: 'Offre exclusive',
        more: 'Quoi de plus',
        mainlandTit: 'Chine continentale',
        hkPackageTit: 'Hong Kong (China) packages',
        popularDestTit: 'Popular destinations',
        countryList: {
            cn: 'Mainland China',
            singapore: 'Singapore',
            hk: 'Hong Kong(China)',
            us: 'United States',
            thailand: 'Thailand',
            germany: 'Germany',
            italy: 'Italy',
            more: 'Quoi de plus'
        },
        regionalPackage: 'Forfaits de données transrégionaux',
        recommendPackage: 'Nous vous proposons',
        from: 'à partir de',
        guide: 'Guide d\'utilisation pour les débutants',
        sepcialArea: 'Zone',
        lastUpdate: 'dernière mise à jour',
        successRefresh: 'Actualisation terminée'
    },
    packages: {
        sub_title: {
            us: 'À l\'exclusion de Guam et Saipan',
            it: 'applicable au Vatican, à Saint-Marin',
            va: 'applicable en Italie, à Saint-Marin ',
            sm: 'applicable en Italie, au Vatican ',
            ma: 'Sahara occidental inclus',
            eh: 'applicable au Maroc',
            ch: 'Liechtenstein inclus',
            li: 'applicable en Suisse ',
            fr: 'Monaco inclus',
            mc: 'applicable en France',
            fi: 'Aland inclus',
            ax: 'applicable en Finlande ',
            gu: 'applicable à Saipan ',
            mp: 'applicable à Guam '
        },
        unlimited_packages: 'Forfait illimité de données',
        normal_packages: 'Forfait classique de données',
        multi_region_packages: 'Forfait interrégional comprenant {area} ',
        sale_text: 'Remise',
        high_speed_text: ' Internet Haut Débit',
        high_speed_text_year: 'Volume de données à haut débit par mois',
        periodUnit: {
            day: 'journée',
            month: 'Par mois',
            hour: 'Heure',
            year: 'Année'
        },
        periodUnits: {
            day: 'journée',
            month: 'Par mois',
            hour: 'Heure',
            year: 'Année'
        },
        periodUnitSimp: {
            day: 'journée',
            month: 'Par mois',
            hour: 'Heure',
            year: 'Année'
        },
        periodUnitsSimp: {
            day: 'journée',
            month: 'Par mois',
            hour: 'Heure',
            year: 'Année'
        },
        unlimited_good_name: {
            day: 'Illimité par jour',
            month: 'Illimité par mois',
            year: 'Illimité par an'
        },
        day_invalid: 'Expire dans la journée',
        month_invalid: 'Expire dans le mois en cours',
        immediate_valid: 'Immédiatement opérationnel',
        tomorrow_day_valid: 'Activer demain',
        tomorrow_month_valid: 'Activer le mois prochain'
    },
    point: (_point = {
        title: 'Mes points',
        point_history: 'Détails des points',
        my_point: 'Mes points',
        will_expire_on: 'Les points sont valables jusqu\'au',
        total: 'au total',
        more: 'Quoi de plus',
        redeem_for_package: 'Convertir en volume de données',
        redeem_for_balance: 'Limite de conversion',
        redeem_for_coupon: 'Coupons de conversion',
        points: 's\'inscrire',
        signIn: "Enregistrement",
        getPrizes: "Gagner des Prix",
        getPoint: " Gagner des points",
        lottery: "Points & Récompenses",
        dataPlans: "Échanger des données",
        Balance: "Échanger le solde",
        coupon: "Échanger des coupons"
    }, defineProperty_default()(_point, 'getPrizes', "Remporter un grand prix"), defineProperty_default()(_point, 'membership_point_rules', 'Instructions d\'utilisation des points de membre'), defineProperty_default()(_point, 'got_it', 'OK'), defineProperty_default()(_point, 'tabs', {
        all: 'Tous les bundles',
        earn: 'obtenir',
        redeem: 'Remboursement'
    }), defineProperty_default()(_point, 'upgradeApp', "Veuillez mettre à jour vers la dernière version de l'application"), _point),
    member: {
        membership: 'membre',
        hello_member: 'Bonjour, cher membre',
        update: 'Surclassement',
        vip_member_benefits: 'Privilèges des membres VIP',
        packages: 'Data bundle',
        discounts: 'DISCOUNT!',
        points: 'Points',
        membership_policy: 'Accord d\'adhésion',
        faq: 'Questions frquentes',
        update_to_vip_membership: 'S\'inscrire en tant que membre VIP',
        vip_member: 'membre VIP',
        valid_till: 'Valid till',
        renew: 'Renouvellement',
        months: 'Par mois',
        payment: 'Confirmation de commande',
        vip_membership: 'membre VIP',
        enjoy_vip_member_benefits: 'Profitez des privilèges des membres VIP {len} !',
        by_purchasing_you_agree_to: 'Tout achat implique le consentement',
        coupon: 'Remise',
        available_coupon: '{num} disponible(s)',
        no_available_coupon: 'Aucun coupon disponible',
        actual_price: 'Montant payé',
        payment_success_text: 'Une fois l\'achat réussi, le forfait de données correspondant peut être automatiquement crédité sur le compte. ',
        balance: 'Solde',
        online_payment: 'Paiements en ligne',
        faq_title: 'Questions frquentes',
        policy_title: 'Confidentialité des membres',
        introduce_title: 'Instructions pour les membres'
    },
    order: {
        periodUnit: {
            day: 'journée',
            month: 'Par mois',
            year: 'Année'
        },
        periodUnits: {
            day: 'journée',
            month: 'Par mois',
            year: 'Année'
        },
        balance_payment_dialog: {
            title: 'Confirmer le paiement',
            content: 'Paiement depuis votre solde',
            noSelectPackageTitle: 'Aucun plan sélectionné',
            noSelectPackageContent: 'Choisissez d\'abord un package'
        },
        purcase_successful: 'Purchase Successful',
        vip_membership: 'membre VIP',
        total: 'montant du paiement',
        finish_btn: 'Revenir',
        get_order_status: 'Getting the order status, please wait...',
        order_status_tip: 'En attente de confirmation',
        order_status_note_user: 'Le paiement par carte bancaire/ carte de crédit n\'est pas autorisé. Veuillez contacter notre service clientèle.',
        order_status_btn_text: 'complètement',
        ios_iap_pay_btn: 'paiement immédiat'
    },
    faq: {
        page_title: 'Questions frquentes',
        mydevice: 'Mes appareils',
        more: 'plus d\'appareils',
        more_faq: 'plus de questions',
        all_device: 'tous les appareils',
        faq_detail: 'Détails'
    },
    device: {
        page_title: 'Guide d\'utilisation des appareils'
    },
    vpn: {
        page_title: 'Foire aux questions VPN',
        faq_detail: 'Détails'
    },
    eism: {
        page_title: 'Foire aux questions ESIM',
        faq_detail: 'ESIM Détails'
    },
    /*
    deviceGuide: {
        title: '请选择你的设备',
        skip: '跳过',
    },
    give_set: {
        give_set_page_title: '赠送流量设置',
        give_set_page_set_btn: '保存',
        title: '会员赠送套餐设置',
        desc: '升级会员成功后，我们将会定期赠送流量包至您设置的设备上，未绑定设备将不能接收赠送流量包！',
        select_device_placeholder: '请选择设备',
        select_device_title: '选择设备',
        no_device_title: '你还未绑定设备',
        no_device_desc: '请选择绑定设备类型',
        bind_type_by_scan: '扫一扫',
        bind_type_by_type: '按类型',
        disable_device_desc: '赠送流量包无法在您绑定的设备上使用，请绑定对应的设备',
        bind_device: '绑定设备',
        give_set_success: '设置成功',
        give_set_leave_desc: '当前设置未保存，确定离开当前页面吗？',
        give_guide_tip: '点击这里可编辑赠送流量设置哦！',
        get_it: '知道了',
        give_set_saved: '保存成功'
    }
    */
    deviceGuide: {
        title: 'Please select your device',
        skip: 'Skip'
    },
    give_set: {
        give_set_page_title: 'Complimentary traffic setting',
        give_set_page_set_btn: 'Save',
        title: 'Complimentary package setting for members',
        desc: 'After upgrading to member, we will send the data package to your device on a regular basis except unbound devices!',
        select_device_placeholder: 'Please select the device',
        select_device_title: 'Select the device',
        no_device_title: 'You haven’t bind device yet',
        no_device_desc: 'Please select a device type for binding',
        bind_type_by_scan: 'Scan',
        bind_type_by_type: 'Model',
        disable_device_desc: 'The complimentary traffic packet can\'t be used on the device which you bound. Please bind the corresponding device',
        bind_device: 'Bind device',
        give_set_success: 'Set Successfully',
        give_set_leave_desc: 'Your settings are not saved, are you sure to leave the current page?',
        give_guide_tip: 'Click here to edit complimentary traffic setting!',
        get_it: 'Got it',
        give_set_saved: 'Saved'
    },
    guide: {
        newUser: {
            title: 'Guidelines',
            top_bar: {
                device: 'I want to use the device network',
                sim: 'I want to use the SIM card network'
            },
            step: {
                title: 'How to use the device to access the internet?',
                bind_device: 'Bind device',
                buy_package: 'Purchase data',
                use: 'Get started'
            },
            sub_bar: {
                device: 'Device',
                package: 'Data',
                use: 'Start'
            },
            content: {
                device: {
                    title: 'How to bind device?',
                    q1: '1.Follow the instructions in your device documentation',
                    q2: '2.Check the QR Code on your device (For device with screen: shown on the home screen - More settings)',
                    q3: '3.Click bind button to bind device on the app homepage'
                },
                package: {
                    title: 'How to purchase data package?',
                    q1: '1.View product information on Data Store homepage',
                    q2: '2.Click purchase button to buy it'
                },
                use: {
                    title: 'How do I start to access the Internet?',
                    q1: '1.After a local service data package is purchased, it will be activated automatically when you turn on the device (Restart the device that has been started)',
                    q2: '2.After a global service data package is purchased, it will be activated automatically when you turn on the device at your destination. After the device is successfully connected to the Internet, you can access the Internet freely.',
                    q2_desc: '(It will take 2-3 minutes to connect to the Internet for the first time, please wait patiently)'
                },
                sim: {
                    title: 'How to access the Internet with SIM card?',
                    q1: '1. Insert available SIM card into the device card slot according to the instructions and restart the device for normal operation (For device with screen: you need to switch to SIM card mode on the screen)',
                    q2: '2.You can also connect to device WIFI with cellphone. Click SIM function to switch to SIM Mode on your App Detail Page'
                }
            }
        }
    }
});
// CONCATENATED MODULE: ./src/lang/ko-KR.js
/* harmony default export */ var ko_KR = ({
    faq: {
        faq_detail: '상세'
    }
});
// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-i18n/dist/vue-i18n.esm.js
var vue_i18n_esm = __webpack_require__("TXmL");

// EXTERNAL MODULE: ./src/utils/cookie.js
var cookie = __webpack_require__("iPXC");

// CONCATENATED MODULE: ./src/lang/index.js











vue_esm["a" /* default */].use(vue_i18n_esm["a" /* default */]);

var messages = {
  "zh-CN": zh_cn,
  "en-US": en_us,
  "zh-TW": zh_TW,
  "zh-HK": zh_TW,
  "ja-JP": ja_JP,
  "fr-FR": fr_FR,
  "ko-KR": ko_KR
};
var dateFormate = {
  "zh-CN": {
    short: {
      year: 'numeric', month: 'numeric', day: 'numeric'
    },
    long: {
      year: 'numeric', month: 'short', day: 'numeric',
      weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: true
    }
  },
  "en-US": {
    short: {
      year: 'numeric', month: 'numeric', day: 'numeric'
    },
    long: {
      year: 'numeric', month: 'short', day: 'numeric',
      weekday: 'short', hour: 'numeric', minute: 'numeric'
    }
  }
};
var defaultLanguage = "en-US";
var localLang = cookie["a" /* default */].get("lang");
var language = localLang || defaultLanguage;
var lang;
switch (language) {
  case "zh-CN":
    lang = "zh-CN";
    break;
  case "en-US":
    lang = "en-US";
    break;
  case "zh-HK":
  case "zh-TW":
    lang = "zh-TW";
    break;
  case "ja-JP":
    lang = "ja-JP";
    break;
  case "fr-FR":
    lang = "fr-FR";
    break;
  case "ko-KR":
    lang = "ko-KR";
    break;
  default:
    lang = "en-US";
}

cookie["a" /* default */].set("lang", lang);

var i18n = new vue_i18n_esm["a" /* default */]({
  locale: language,
  messages: messages,
  dateTimeFormats: dateFormate, //日期格式化$d
  fallbackLocale: "en-US",
  silentTranslationWarn: true
});

/* harmony default export */ var src_lang = __webpack_exports__["a"] = (i18n);

/***/ }),

/***/ "dXft":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fgbW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fghJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iPXC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Cookie; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__("Zx67");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__("zwoO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__("Pf15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_js_cookie__);







var Cookie = function (_Cookies) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Cookie, _Cookies);

  function Cookie() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Cookie);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Cookie.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Cookie)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Cookie, null, [{
    key: 'setDefaults',
    value: function setDefaults(defaults) {
      __WEBPACK_IMPORTED_MODULE_5_js_cookie___default.a.defaults = defaults;
    }
  }, {
    key: 'getAllCookie',
    value: function getAllCookie() {
      return this.get();
    }
  }, {
    key: 'clearAllCookie',
    value: function clearAllCookie() {
      var cookies = this.get();
      for (var i in cookies) {
        this.remove(i, { domain: document.domain.split('.').slice(-2).join('.') });
        this.remove(i, { domain: location.hostname });
      }
    }
  }, {
    key: 'setCookies',
    value: function setCookies(arr) {
      var _this2 = this;

      arr.forEach(function (v, i) {
        _this2.set(v['key'], v['value'], { expires: v['expires'], path: v['path'] || '/' });
      });
    }
  }]);

  return Cookie;
}(__WEBPACK_IMPORTED_MODULE_5_js_cookie___default.a);

Cookie.getCookie = Cookie.get;
Cookie.setCookie = Cookie.set;
Cookie.clearCookie = Cookie.remove;



/***/ }),

/***/ "kJS3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

var pkg = __webpack_require__("7YgM");
var get = function get(url) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open("get", url, true);
        xhr.onload = function () {
            if (xhr.status == 200) {
                resolve(JSON.parse(xhr.responseText));
            } else {
                reject(null);
            }
        };
        xhr.onerror = function () {
            reject(null);
        };
        xhr.send(null);
    });
};

/* harmony default export */ __webpack_exports__["a"] = ({
    getConfig: function getConfig() {
        var hash = Math.random();
        if (true) {
            return get("/webmall/" + pkg.version + "/config/app-config.json?streamNo=v" + (new Date().getTime() + parseInt(Math.random() * 1000000)));
        } else {
            return get("/webmall/config/app-config.json?streamNo=v" + (new Date().getTime() + parseInt(Math.random() * 1000000)));
        }
    }
});

/***/ }),

/***/ "kbG3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var components_inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-291627fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/inline-desc/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vux-label-desc"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_inline_desc = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/inline-desc/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("dXft")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_inline_desc,
  src_components_inline_desc,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_inline_desc = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mZ3l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mzja":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/components/x-dialog/index.vue + 3 modules
var x_dialog = __webpack_require__("/kga");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_alert = ({
  name: 'alert',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var src_components_alert = ({
  name: 'alert',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0222073a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/alert/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-alert"},[_c('x-dialog',{attrs:{"mask-transition":_vm.maskTransition,"dialog-transition":_vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){_vm.$emit('on-hide')},"on-show":function($event){_vm.$emit('on-show')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[_c('div',{staticClass:"weui-dialog__hd"},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],2),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_primary",attrs:{"href":"javascript:;"},on:{"click":_vm._onHide}},[_vm._v(_vm._s(_vm.buttonText || '确定'))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var vux_src_components_alert = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/alert/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("B+uB")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_components_alert,
  vux_src_components_alert,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var node_modules_vux_src_components_alert = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oFuF":
/***/ (function(module, exports) {

/*
* 判断类型
* */

var toString = Object.prototype.toString;
exports.isString = function (obj) {
    return toString.call(obj) === '[object String]';
};
exports.isObject = function (obj) {
    return toString.call(obj) === '[object Object]';
};
exports.isBoolean = function (obj) {
    return toString.call(obj) === '[object Boolean]';
};
exports.isNumber = function (obj) {
    return toString.call(obj) === '[object Number]';
};
exports.isFunction = function (obj) {
    return toString.call(obj) === '[object Function]';
};
exports.isArray = function (obj) {
    return toString.call(obj) === '[object Array]';
};

/*
* @arr 数据源
* @target 目标对象
* @key 匹配的对象属性
* */
exports.getArrayObjIndex = function (arr, target, key) {
    for (var i = 0, len = arr.length; i < len; i++) {
        if (arr[i][key] === target[key]) {
            return i;
        }
    }
};

exports.isUndefOrEmpty = function (val) {
    return val === '' || val === undefined || val === null;
};

//保留两位小数的方法 四舍五入法
exports.keepTwodecimalFull = function (num) {
    var result = parseFloat(num);
    if (isNaN(result)) {
        return "";
    }
    result = Math.round(num * 100) / 100;
    var s_x = result.toString();
    var pos_decimal = s_x.indexOf('.'); //小数点的所索引值

    //当整数时，pos_decimal = -1 自动补0
    if (pos_decimal < 0) {
        pos_decimal = s_x.length;
        s_x += '.';
    }
    while (s_x.length <= pos_decimal + 2) {
        s_x += '0';
    }
    return s_x;
};

//保留两位小数的方法 不四舍五入法
exports.keepTwodecimalFixed = function (num) {
    var result = parseFloat(num);
    if (isNaN(result)) {
        return "";
    }

    return (parseInt(num * 100) / 100).toFixed(2);
};
exports.createalphabetList = function () {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'dict';

    var alphabetList = void 0;
    type == 'dict' ? alphabetList = {} : alphabetList = [];
    for (var i = 0; i <= 25; i++) {
        var letter = String.fromCharCode(i + 65);
        if (type == 'list') {
            alphabetList.push(letter);
        } else if (type == 'dict') {
            alphabetList[i] = letter;
        }
    }
    return alphabetList;
};

exports.getUrlParam = function () {
    var name = void 0,
        value = void 0;
    var str = location.href;
    var num = str.indexOf("?");
    str = str.substr(num + 1); //取得所有参数   stringvar.substr(start [, length ]
    var arr = str.split("&"); //各个参数放到数组里
    var param = {};
    for (var i = 0; i < arr.length; i++) {
        num = arr[i].indexOf("=");
        if (num > 0) {
            name = arr[i].substring(0, num);
            value = arr[i].substr(num + 1);
            param[name] = value;
        }
    }
    return param;
};

exports.throttle = function (fn, wait) {
    var timer = void 0;
    return function () {
        var _this = this,
            _arguments = arguments;

        if (!timer) {
            timer = setTimeout(function () {
                timer = null;
                fn.apply(_this, _arguments);
            }, wait);
        }
    };
};

exports.debounce = function (fn, wait) {
    var timeout = null;
    return function () {
        if (timeout !== null) clearTimeout(timeout);
        timeout = setTimeout(fn, wait);
    };
};

var getBrowserGMT = function getBrowserGMT() {
    var dates = new Date();
    return -dates.getTimezoneOffset() / 60;
};

exports.getFormatTime = function (d, ks) {
    d = d + ((ks - getBrowserGMT()) * 60 || 0) * 60000;
    var date = new Date(d),
        Y,
        M,
        D,
        h,
        m,
        s;
    if (!d) {
        return;
    }
    if (parseInt(d) < 86400) {
        return d;
    }
    d = d;
    Y = date.getFullYear() + '/';
    M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '/';
    M = M < 10 ? "0" + M : M;
    D = date.getDate() + ' ' < 10 ? "0" + (date.getDate() + ' ') : date.getDate() + ' ';
    h = date.getHours();
    h = (h < 10 ? "0" + h : h) + ':';
    m = date.getMinutes();
    m = (m < 10 ? "0" + m : m) + ':';
    s = date.getSeconds();
    s = s < 10 ? "0" + s : s;
    var dayTime = h + m + s;
    if (dayTime === '00:00:00') {
        return Y + M + D;
    }
    return Y + M + D + h + m + s;
};

exports.getFormatTimeUS = function (d, ks) {
    d = d + ((ks - getBrowserGMT()) * 60 || 0) * 60000;
    var date = new Date(d),
        Y,
        M,
        D,
        h,
        m,
        s;
    if (!d) {
        return;
    }
    if (parseInt(d) < 86400) {
        return d;
    }
    d = d;
    Y = date.getFullYear() + " ";
    M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
    M = M + '/';
    D = date.getDate() + ' ' < 10 ? "0" + date.getDate() : date.getDate();
    D = D + '/';
    h = date.getHours();
    h = (h < 10 ? "0" + h : h) + ':';
    m = date.getMinutes();
    m = (m < 10 ? "0" + m : m) + ':';
    s = date.getSeconds();
    s = s < 10 ? "0" + s : s;
    var dayTime = h + m + s;
    if (dayTime === '00:00:00') {
        return M + D + Y;
    }
    return M + D + Y + h + m + s;
};

exports.randomString = function () {
    var len = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 6;

    var str = 'abcdefghijklmnopqrstuvwxyz0123456789_/+=';
    var res = '';
    for (var i = 0; i < len; i++) {
        var index = Math.floor(Math.random() * str.length);
        res += str.charAt(index);
    }

    return res;
};

exports.getENV = function () {
    return function () {
        var u = navigator.userAgent;
        var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
        var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    };
};
exports.isAndroid = function () {
    var u = navigator.userAgent;
    return u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
};

exports.isIOS = function () {
    var u = navigator.userAgent;
    return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
};

exports.toQueryParams = function (obj) {
    var params = new URLSearchParams();

    var _loop = function _loop(key) {
        var it = obj[key];
        if (Array.isArray(it)) {
            value.forEach(function (val) {
                return params.append(key, val);
            });
        } else {
            params.append(key, it);
        }
    };

    for (var key in obj) {
        _loop(key);
    }
    return params.toString();
};

/***/ }),

/***/ "oWtu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var components_icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7d30802","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/icon/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:[_vm.className, _vm.isMsg ? 'weui-icon_msg' : '']})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_icon = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/icon/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("PBVh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_icon,
  src_components_icon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_icon = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "oy94":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rHil":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/libs/clean-style.js
var clean_style = __webpack_require__("wmxo");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e216ed4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/group/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.title)?_c('div',{staticClass:"weui-cells__title",style:(_vm.cleanStyle({
    color: _vm.titleColor
  })),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),_vm._t("title"),_vm._v(" "),_c('div',{staticClass:"weui-cells",class:{
    'vux-no-group-title': !_vm.title
  },style:(_vm.cleanStyle({
    marginTop: typeof _vm.gutter === 'number' ? (_vm.gutter + 'px') : _vm.gutter
  }))},[_vm._t("after-title"),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),(_vm.footerTitle)?_c('div',{staticClass:"weui-cells__title vux-group-footer-title",style:(_vm.cleanStyle({
    color: _vm.footerTitleColor
  })),domProps:{"innerHTML":_vm._s(_vm.footerTitle)}}):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_group = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/group/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("mZ3l")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_group,
  src_components_group,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_group = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rLAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/safari-fix.js
var safari_fix = __webpack_require__("xNvf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25afd1ad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/toast/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-toast"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMask && _vm.show),expression:"isShowMask && show"}],staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.currentTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-toast",class:_vm.toastClass,style:({width: _vm.width})},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.type !== 'text'),expression:"type !== 'text'"}],staticClass:"weui-icon-success-no-circle weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('p',{staticClass:"weui-toast__content",style:(_vm.style)},[_vm._t("default")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_toast = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/toast/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("+OsR")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_toast,
  src_components_toast,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_toast = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "x79i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.aeb1eb878860ed032eda.js